import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable, Post } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getConnection, In, Like, MoreThan, Not, Raw, Repository } from 'typeorm';
import { CommentsService } from '../comments/comments.service';
import { HierarchyEntity } from '../hierarchy/hierarchy.entity';
import { PollVotingEntity } from '../poll/poll-voting.entity';
import { PollService } from '../poll/poll.service';
import { PostActivityService } from '../post-activity/post-activity.service';
import { PostFilesService } from '../post-files/post-files.service';
import { ProfileService } from '../profile/profile.service';
import { AllPCategoryResponseModel, AllPostsResponseModel, PointsResponseModel, PostResponseModel, SingleResponseModel } from './dto/post-response-model';
import { GSearchDto, JobDto, Pagination1Dto, Pagination2Dto, Pagination3Dto, PaginationDto, PercentDto, PinPostDto, PostApprvDto, PostDeleteDto, PostDTO, PostMSGDto } from './dto/post.dto';
import { PostEntity } from './post.entity';
import * as fs from 'fs';
import { PostPointsEntity } from './post-points.entity';
import { UserPointsEntity } from './user-points.entity';
import { DevelopmentStatusEntity } from '../developmentpost/developmentpost.entity';
import { UserEntity } from '../user/user.entity';
import { PostCategoryEntity } from './post-category.entity';
import { sendWhatsAppTxtMSG, sendWhatsAppImgMSG, sendWhatsAppVideoMSG, sendMailInfo1 } from '../shared/mobileOTP';
import { empty } from 'rxjs';
import { PostJobsEntity } from './jobs.entity';
import { PostMsgsEntity } from './cronjobs.entity';
import { AppSettingEntity } from './app-settings.entity';
import { WhatsappGroupsEntity } from '../whatsapp/whatsappgrp.entity';

@Injectable()
export class PostService {
    constructor (
        @InjectRepository(PostEntity)
        private postRepository: Repository<PostEntity>, 
        @InjectRepository(HierarchyEntity)
        private hierarchyRepo: Repository<HierarchyEntity>,
        @InjectRepository(UserEntity)
        private useRepo: Repository<UserEntity>,
        @InjectRepository(PostPointsEntity)
        private postPointsRepo: Repository<PostPointsEntity>,
        @InjectRepository(UserPointsEntity)
        private userPointsRepo:Repository<UserPointsEntity>,
        @InjectRepository(DevelopmentStatusEntity)
        private developmentpostRepo: Repository<DevelopmentStatusEntity>,
        @InjectRepository(PostCategoryEntity)
        private postCategoryRepo:Repository<PostCategoryEntity>,
        @InjectRepository(PostJobsEntity)
        private pjobsRepo:Repository<PostJobsEntity>,
        @InjectRepository(PostMsgsEntity)
        private pmsgsRepo:Repository<PostMsgsEntity>,
        @InjectRepository(AppSettingEntity)
        private apsetRepo:Repository<AppSettingEntity>,
        @InjectRepository(WhatsappGroupsEntity)
        private whatgrpRepo:Repository<WhatsappGroupsEntity>,
        private postFilesService: PostFilesService,
        private pollService: PollService, 
        private profileService: ProfileService, 
        private postActService: PostActivityService,
        private cmntService: CommentsService,     
    ) {}
  
    async sendMail(reciver:string,anmsg:string, file:string) {
        return await sendMailInfo1(reciver,anmsg,file)
        .then(() => {
          console.log('mail sent successufully');
          return true;			
        })
        .catch((err) => {
          console.log('error in sending email ', err);
          return false;
        });
    }


    async sendWhatsAppImg(img,cap,txt,to) {
        const data = await this.apsetRepo.findOne({
            where: {type:'Whatsapp',status:1},
        });
        var wkey = data && data.wupkey != undefined ? data.wupkey : '';
        var winst = data && data.wupinstnce != undefined ? data.wupinstnce : '';

        return await sendWhatsAppImgMSG(img,cap,txt,to,wkey,winst)
        .then(() => {      
          console.log('msg sent successufully'+img);
          return true;
        })
        .catch((err) => {
          console.log('error in sending msg ', err);
          return false;
        });
    }

    async sendWhatsAppTxt(txt,to) {
        const data = await this.apsetRepo.findOne({
            where: {type:'Whatsapp',status:1},
        });
        var wkey = data && data.wupkey != undefined ? data.wupkey : '';
        var winst = data && data.wupinstnce != undefined ? data.wupinstnce : '';
        return await sendWhatsAppTxtMSG(txt,to,wkey,winst)
        .then(() => {      
          console.log('msg sent successufully');
          return true;
        })
        .catch((err) => {
          console.log('error in sending msg ', err);
          return false;
        });
    }

    async sendWhatsAppVideo(img,cap,txt,to) {
        const data = await this.apsetRepo.findOne({
            where: {type:'Whatsapp',status:1},
        });
        var wkey = data && data.wupkey != undefined ? data.wupkey : '';
        var winst = data && data.wupinstnce != undefined ? data.wupinstnce : '';
        return await sendWhatsAppVideoMSG(img,cap,txt,to,wkey,winst)
        .then(() => {      
          console.log('msg sent successufully'+img);
          return true;
        })
        .catch((err) => {
          console.log('error in sending msg ', err);
          return false;
        });
    }

    timeDiffCalc(dateFuture, dateNow) {
        // console.log(dateNow.toLocaleString({ timeZone: 'IST' }))
         let diffInMilliSeconds = Math.abs(dateFuture - dateNow) / 1000;
     
         // calculate days
         const days = Math.floor(diffInMilliSeconds / 86400);
         diffInMilliSeconds -= days * 86400;
         console.log('calculated days', days);
     
         // calculate hours
         const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
         diffInMilliSeconds -= hours * 3600;
         console.log('calculated hours', hours);
     
         // calculate minutes
         const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
         diffInMilliSeconds -= minutes * 60;
         console.log('minutes', minutes);
     
         let difference = '';
         if (days > 0) {
           difference += (days === 1) ? `${days} day, ` : `${days} days, `;
         }
     
         difference += (hours === 0 || hours === 1) ? `${hours} hour, ` : `${hours} hours, `;
     
         difference += (minutes === 0 || hours === 1) ? `${minutes} minutes` : `${minutes} minutes`; 
     
         return difference;
     }

    async createPost(queryParams,postDto:PostDTO,request:Request): Promise<PostResponseModel> {
        const response = new PostResponseModel();
        try {
           
            if(postDto.isDevelopmentPost == 1){
                postDto.developStatus ='new';
            } else {
                postDto.developStatus = '';
            }
            if(postDto.villageId > 0) {
                postDto.villageId = postDto.villageId;
            } else {
                postDto.villageId = null;
            } 
            if(postDto.postCategoryId) {
                postDto.postCategoryId = postDto.postCategoryId;
            } else {
                postDto.postCategoryId = null;
            } 
            var frshuseRole = await this.useRepo.findOne({
                where:{Id:postDto.userId}
            });

            var apset = await this.apsetRepo.findOne({
                where:{type:'Whatsapp'}
            });

            if(frshuseRole && (frshuseRole.roleId == 1 || frshuseRole.roleId == 2) ) { 
                postDto.status = 1;
            } else {
                if(postDto.isJobPost == 1) 
                    postDto.status = 1;
                else 
                    postDto.status = 2;
            }
            let andurl = '';
            let iosurl = '';
            const configdt = await this.apsetRepo.findOne({
                where:{type:'Config'},
                order: { Id: 'ASC' }
            }); 

            if(configdt) {
                if(configdt.android != null && configdt.android != '')
                    andurl = configdt.android;
                
                if(configdt.ios != null && configdt.ios != '')
                    iosurl = configdt.ios;
            }
            if(queryParams.apiVersion == 1) {
                const savedPost = await this.postRepository.save(postDto);
                if(savedPost) {
                    if(postDto.isDevelopmentPost == 1){
                        await this.developmentpostRepo.save({
                            postId:savedPost.Id,
                            developmentStatus:'New',
                            createdUser:savedPost.userId
                        })
                    } 

                    if(apset.status == 1) {
                        if(frshuseRole && (frshuseRole.roleId == 1 || frshuseRole.roleId == 2) ) { 
                            let currDt = new Date().toJSON().slice(0, 10);
    
                            const postdumrec = await this.pmsgsRepo.findOne({
                                where:{insDate: currDt},
                                order:{createdAt: "DESC"}
                            });

                            let [whatsids, grpcount] = await this.whatgrpRepo.findAndCount({
                                where:{status:1},
                                order:{Id:'ASC'}
                            });
                            
                            var udata =  [];
                            var udataids = [];
    
                            if(postdumrec) {
                                if(postdumrec.remains > 0) {
                                    let newcnt = ++postdumrec.lcount;
                                    let newrm = postdumrec.remains - 500;
                                    let newuid = postdumrec.userId;
                                    let limt = 500;
                                    if(grpcount <= 500)
                                        limt -= grpcount;
                    
                                    whatsids.map((u) => {
                                        udata.push(u.groupId);
                                    });
                    
                                    const remUsers = await this.useRepo.find({
                                        where:{status:true,Id:MoreThan(newuid)},
                                        order:{Id:'ASC'},
                                        take: limt
                                    });
                    
                                    if(remUsers.length > 0)  {
                                        remUsers.map((u) => {
                                            udata.push(u.mobileNo);
                                            udataids.push(u.Id);
                                        });
                                        
                                        if(udata.length > 0) {
                                            let lastItem = udataids[udataids.length - 1];
                                            limt -= udata.length;
                                            newrm += limt;
                                            await this.pmsgsRepo.save({
                                                postId:savedPost.Id,
                                                userId: lastItem,
                                                sent: udata.length,
                                                remains: newrm,
                                                lcount: newcnt,
                                                insDate: currDt
                                            });
                                            var mob = udata.toString();
                                            var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                            var txt = savedPost.text;
                                            var to = mob;
                                            this.sendWhatsAppTxt(txt,to);
                                        } 
                                    } else  {
                                        const remnUsers = await this.useRepo.find({
                                            where:{status:true},
                                            order:{Id:'ASC'},
                                            take: limt
                                        });
                    
                                        if(remnUsers.length > 0)  {                                            
                                            remnUsers.map((u) => {
                                                udata.push(u.mobileNo);
                                                udataids.push(u.Id);
                                            });
                                            
                                            if(udata.length > 0) {
                                                let lastItem = udataids[udataids.length - 1];
                                                limt -= udata.length;
                                                newrm += limt;
                                                await this.pmsgsRepo.save({
                                                    postId:savedPost.Id,
                                                    userId: lastItem,
                                                    sent: udata.length,
                                                    remains: newrm,
                                                    lcount: newcnt,
                                                    insDate: currDt
                                                });
                                                var mob = udata.toString();
                                                var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                var txt = savedPost.text;
                                                var to = mob;
                                                this.sendWhatsAppTxt(txt,to);
                    
                                            } 
                                        }
                                    }                               
                                }
                            } else {                                
                                const postdumrec1 = await this.pmsgsRepo.findOne({
                                    order:{createdAt: "DESC"}
                                });
                                if(postdumrec1) {
                                    let newcnt = 1;
                                    let newrm = 4000;
                                    let newuid = postdumrec1.userId;
                                    let limt = 500;
                                    if(grpcount <= 500)
                                        limt -= grpcount;
                    
                                    whatsids.map((u) => {
                                        udata.push(u.groupId);
                                    });
                                    const remUsers = await this.useRepo.find({
                                        where:{status:true,Id:MoreThan(newuid)},
                                        order:{Id:'ASC'},
                                        take: limt
                                    });
                    
                                    if(remUsers.length > 0)  {
                                        
                                        remUsers.map((u) => {
                                            udata.push(u.mobileNo);
                                            udataids.push(u.Id);
                                        });
                                        
                                        if(udata.length > 0) {
                                            let lastItem = udataids[udataids.length - 1];
                                            limt -= udata.length;
                                            newrm += limt;
                                            await this.pmsgsRepo.save({
                                                postId:savedPost.Id,
                                                userId: lastItem,
                                                sent: udata.length,
                                                remains: newrm,
                                                lcount: newcnt,
                                                insDate: currDt
                                            });
                                            var mob = udata.toString();
                                            var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                            var txt = savedPost.text;
                                            var to = mob;
                                            this.sendWhatsAppTxt(txt,to);    
                                        } 
                                    } else {
                                        const remnUsers = await this.useRepo.find({
                                            where:{status:true},
                                            order:{Id:'ASC'},
                                            take: limt
                                        });
                                        if(remnUsers.length > 0)  {
                                            
                                            remnUsers.map((u) => {
                                                udata.push(u.mobileNo);
                                                udataids.push(u.Id);
                                            });
                                            
                                            if(udata.length > 0) {
                                                let lastItem = udataids[udataids.length - 1];
                                                limt -= udata.length;
                                                newrm += limt;
                                                await this.pmsgsRepo.save({
                                                    postId:savedPost.Id,
                                                    userId: lastItem,
                                                    sent: udata.length,
                                                    remains: newrm,
                                                    lcount: newcnt,
                                                    insDate: currDt
                                                });
                                                var mob = udata.toString();
                                                var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                var txt = savedPost.text;
                                                var to = mob;
                                                this.sendWhatsAppTxt(txt,to);    
                                            } 
                                        } 
                                    }                                
                                } else {                
                                    let newcnt = 1;
                                    let newrm = 4000;
                                    let limt = 500;
                                    if(grpcount <= 500)
                                        limt -= grpcount;
                    
                                    whatsids.map((u) => {
                                        udata.push(u.groupId);
                                    });
                                    
                                    const remUsers = await this.useRepo.find({
                                        where:{status:true},
                                        order:{Id:'ASC'},
                                        take: limt
                                    });
                    
                                    if(remUsers.length > 0)  { 
                                        remUsers.map((u) => {
                                            udata.push(u.mobileNo);
                                            udataids.push(u.Id)
                                        });                                        
                                    }  
                                    if(udata.length > 0) {
                                        let lastItem = udataids[udataids.length - 1];
                                        limt -= udata.length;
                                        newrm += limt; 
                                        await this.pmsgsRepo.save({
                                            postId:savedPost.Id,
                                            userId: lastItem,
                                            sent: udata.length,
                                            remains: newrm,
                                            lcount: newcnt,
                                            insDate: currDt
                                        });
                                        var mob = udata.toString();
                                        var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                        var txt = savedPost.text;
                                        var to = mob;
                                        this.sendWhatsAppTxt(txt,to);    
                                    }                               
                                }
                    
                            }
                            
                        } 
                    }                                                   
           
                    response.status = true;
                    response.data   = savedPost;
                    response.statusCode = 50000;
                    response.internalMessage = 'Post Created Successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Post Not Saved')
                }                
            } else {
                const savedPost = await this.postRepository.save(postDto);
                if(savedPost) {
                    if(postDto.isDevelopmentPost == 1){
                        await this.developmentpostRepo.save({
                            postId:savedPost.Id,
                            developmentStatus:'New',
                            createdUser:savedPost.userId
                        })
                    } 

                    if(apset.status == 1) {
                        if(frshuseRole && (frshuseRole.roleId == 1 || frshuseRole.roleId == 2) ) { 
                            let currDt = new Date().toJSON().slice(0, 10);
    
                            const postdumrec = await this.pmsgsRepo.findOne({
                                where:{insDate: currDt},
                                order:{createdAt: "DESC"}
                            });

                            let [whatsids, grpcount] = await this.whatgrpRepo.findAndCount({
                                where:{status:1},
                                order:{Id:'ASC'}
                            });
                            
                            var udata =  [];
                            var udataids = [];
    
                            if(postdumrec) {
                                if(postdumrec.remains > 0) {
                                    let newcnt = ++postdumrec.lcount;
                                    let newrm = postdumrec.remains - 500;
                                    let newuid = postdumrec.userId;
                                    let limt = 500;
                                    if(grpcount <= 500)
                                        limt -= grpcount;
                    
                                    whatsids.map((u) => {
                                        udata.push(u.groupId);
                                    });
                    
                                    const remUsers = await this.useRepo.find({
                                        where:{status:true,Id:MoreThan(newuid)},
                                        order:{Id:'ASC'},
                                        take: limt
                                    });
                    
                                    if(remUsers.length > 0)  {
                                        remUsers.map((u) => {
                                            udata.push(u.mobileNo);
                                            udataids.push(u.Id);
                                        });
                                        
                                        if(udata.length > 0) {
                                            let lastItem = udataids[udataids.length - 1];
                                            limt -= udata.length;
                                            newrm += limt;
                                            await this.pmsgsRepo.save({
                                                postId:savedPost.Id,
                                                userId: lastItem,
                                                sent: udata.length,
                                                remains: newrm,
                                                lcount: newcnt,
                                                insDate: currDt
                                            });
                                            var mob = udata.toString();
                                            var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                            var txt = savedPost.text;
                                            var to = mob;
                                            this.sendWhatsAppTxt(txt,to);
                                        } 
                                    } else  {
                                        const remnUsers = await this.useRepo.find({
                                            where:{status:true},
                                            order:{Id:'ASC'},
                                            take: limt
                                        });
                    
                                        if(remnUsers.length > 0)  {
                                            
                                            remnUsers.map((u) => {
                                                udata.push(u.mobileNo);
                                                udataids.push(u.Id);
                                            });
                                            
                                            if(udata.length > 0) {
                                                let lastItem = udataids[udataids.length - 1];
                                                limt -= udata.length;
                                                newrm += limt;
                                                await this.pmsgsRepo.save({
                                                    postId:savedPost.Id,
                                                    userId: lastItem,
                                                    sent: udata.length,
                                                    remains: newrm,
                                                    lcount: newcnt,
                                                    insDate: currDt
                                                });
                                                var mob = udata.toString();
                                                var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                var txt = savedPost.text ;
                                                var to = mob;
                                                this.sendWhatsAppTxt(txt,to);
                    
                                            } 
                                        }
                                    }                               
                                }
                            } else {                                
                                const postdumrec1 = await this.pmsgsRepo.findOne({
                                    order:{createdAt: "DESC"}
                                });
                                if(postdumrec1) {
                                    let newcnt = 1;
                                    let newrm = 4000;
                                    let newuid = postdumrec1.userId;
                                    let limt = 500;
                                    if(grpcount <= 500)
                                        limt -= grpcount;
                    
                                    whatsids.map((u) => {
                                        udata.push(u.groupId);
                                    });
                                    const remUsers = await this.useRepo.find({
                                        where:{status:true,Id:MoreThan(newuid)},
                                        order:{Id:'ASC'},
                                        take: limt
                                    });
                    
                                    if(remUsers.length > 0)  {
                                        
                                        remUsers.map((u) => {
                                            udata.push(u.mobileNo);
                                            udataids.push(u.Id);
                                        });
                                        
                                        if(udata.length > 0) {
                                            let lastItem = udataids[udataids.length - 1];
                                            limt -= udata.length;
                                            newrm += limt;
                                            await this.pmsgsRepo.save({
                                                postId:savedPost.Id,
                                                userId: lastItem,
                                                sent: udata.length,
                                                remains: newrm,
                                                lcount: newcnt,
                                                insDate: currDt
                                            });
                                            var mob = udata.toString();
                                            var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                            var txt = savedPost.text ;
                                            var to = mob;
                                            this.sendWhatsAppTxt(txt,to);    
                                        } 
                                    } else {
                                        const remnUsers = await this.useRepo.find({
                                            where:{status:true},
                                            order:{Id:'ASC'},
                                            take: limt
                                        });
                                        if(remnUsers.length > 0)  {
                                            
                                            remnUsers.map((u) => {
                                                udata.push(u.mobileNo);
                                                udataids.push(u.Id);
                                            });
                                            
                                            if(udata.length > 0) {
                                                let lastItem = udataids[udataids.length - 1];
                                                limt -= udata.length;
                                                newrm += limt;
                                                await this.pmsgsRepo.save({
                                                    postId:savedPost.Id,
                                                    userId: lastItem,
                                                    sent: udata.length,
                                                    remains: newrm,
                                                    lcount: newcnt,
                                                    insDate: currDt
                                                });
                                                var mob = udata.toString();
                                                var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                var txt = savedPost.text ;
                                                var to = mob;
                                                this.sendWhatsAppTxt(txt,to);    
                                            } 
                                        } 
                                    }                                
                                } else {                
                                    let newcnt = 1;
                                    let newrm = 4000;
                                    let limt = 500;
                                    if(grpcount <= 500)
                                        limt -= grpcount;
                    
                                    whatsids.map((u) => {
                                        udata.push(u.groupId);
                                    });
                                    
                                    const remUsers = await this.useRepo.find({
                                        where:{status:true},
                                        order:{Id:'ASC'},
                                        take: limt
                                    });
                    
                                    if(remUsers.length > 0)  { 
                                        remUsers.map((u) => {
                                            udata.push(u.mobileNo);
                                            udataids.push(u.Id)
                                        });                                        
                                    }  
                                    if(udata.length > 0) {
                                        let lastItem = udataids[udataids.length - 1];
                                        limt -= udata.length;
                                        newrm += limt;
                                        await this.pmsgsRepo.save({
                                            postId:savedPost.Id,
                                            userId: lastItem,
                                            sent: udata.length,
                                            remains: newrm,
                                            lcount: newcnt,
                                            insDate: currDt
                                        });
                                        var mob = udata.toString();
                                        var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                        var txt = savedPost.text ;
                                        var to = mob;
                                        this.sendWhatsAppTxt(txt,to);    
                                    }                               
                                }
                    
                            }
                            
                        } 
                    }                                                   
           
                    response.status = true;
                    response.data   = savedPost;
                    response.statusCode = 50000;
                    response.internalMessage = 'Post Created Successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Post Not Saved')
                }                
            }
            return response;
        } catch (error) {
            throw error;
        }
    }
    
    async createPostWithReturnResult(queryParams, postDto:PostDTO) {
        try {
            if(postDto.isDevelopmentPost == 1){
                postDto.developStatus ='new';
            } else {
                postDto.developStatus = '';
            }
            if(postDto.villageId > 0) {
                postDto.villageId = postDto.villageId;
            } else {
                postDto.villageId = null;
            } 
            if(postDto.postCategoryId) {
                postDto.postCategoryId = postDto.postCategoryId;
            } else {
                postDto.postCategoryId = null;
            } 
            var frshuseRole = await this.useRepo.findOne({
                where:{Id:postDto.userId}
            });           

            if(frshuseRole && (frshuseRole.roleId == 1 || frshuseRole.roleId == 2) ) { 
                postDto.status = 1;
            } else {
                if(postDto.isJobPost == 1) 
                    postDto.status = 1;
                else 
                    postDto.status = 2;
            }
            if(queryParams.apiVersion == 1) {
                const editPost = await this.postRepository.save(postDto);
                if(editPost) {
                    if(postDto.isDevelopmentPost == 1){
                        await this.developmentpostRepo.save({
                            postId:editPost.Id,
                            developmentStatus:'New',
                            createdUser:editPost.userId
                        })
                    }
                    const savedPost = await this.postRepository.findOne({
                        where:{Id:postDto.Id}
                    })
                    
                    return savedPost;
                } else {
                    return null;
                }
            } else {
                const editPost = await this.postRepository.save(postDto);
                if(editPost) {
                    if(postDto.isDevelopmentPost == 1){
                        await this.developmentpostRepo.save({
                            postId:editPost.Id,
                            developmentStatus:'New',
                            createdUser:editPost.userId
                        })
                    }
                    const savedPost = await this.postRepository.findOne({
                        where:{Id:postDto.Id}
                    })                   
                    return savedPost;
                } else {
                    return null;
                }
            }
        } catch (error) {
            throw error;
        }
    }

    async editPostWithReturnResult(queryParams, postDto:PostDTO) {
        try {
            const oldData = await this.postRepository.findOne({
                where:{Id:postDto.Id}
            })
            if(postDto.text) {
                postDto.text = postDto.text;
            } else {
                postDto.text = oldData.text;
            }
            if(postDto.isDevelopmentPost) {
                postDto.isDevelopmentPost = postDto.isDevelopmentPost
            } else {
                postDto.isDevelopmentPost = oldData.isDevelopmentPost
            }
            if(postDto.location) {
                postDto.location = postDto.location
            } else {
                postDto.location = oldData.location
            }
            if(postDto.villageId) {
                postDto.villageId = postDto.villageId
            } else {
                postDto.villageId = oldData.villageId
            }
            if(postDto.postTypeId) {
                postDto.postTypeId = postDto.postTypeId
            } else {
                postDto.postTypeId = oldData.postTypeId
            }
            if(postDto.postCategoryId) {
                postDto.postCategoryId = postDto.postCategoryId
            } else {
                postDto.postCategoryId = oldData.postCategoryId
            }
            const final = {
                text:postDto.text,
                isDevelopmentPost:postDto.isDevelopmentPost,
                location:postDto.location,
                villageId:postDto.villageId,
                postTypeId:postDto.postTypeId,
                postCategoryId:postDto.postCategoryId,
                userId:postDto.userId,
                updatedUser:postDto.updatedUser
            }            
            if(queryParams.apiVersion == 1) {
                const savedPost = await this.postRepository.update(postDto.Id,final);
                if(savedPost) {
                    return savedPost;
                } else {
                    return null;
                }
            } else {
                const savedPost = await this.postRepository.update(postDto.Id,final);
                if(savedPost) {
                    return savedPost;
                } else {
                    return null;
                }
            }
        } catch (error) {
            throw error;
        }
    }

    async createPostAttachments(queryParam, filesData, postId): Promise<PostResponseModel> {
        const response = new PostResponseModel();
        try {
            let andurl = '';
            let iosurl = '';
            const configdt = await this.apsetRepo.findOne({
                where:{type:'Config'},
                order: { Id: 'ASC' }
            }); 

            if(configdt) {
                if(configdt.android != null && configdt.android != '')
                    andurl = configdt.android;
                
                if(configdt.ios != null && configdt.ios != '')
                    iosurl = configdt.ios;
            }
            if(queryParam.apiVersion == 1) {
                let images: any[] = [];
                const fileUpload = await this.postFilesService.createPostAttachments(filesData);
                if(fileUpload) {
                    const savedPostData = await this.postRepository.findOne({
                        relations:['posttype','postfiles'],
                        where:{Id:postId}
                    });
                    if(savedPostData) {
                        var apset = await this.apsetRepo.findOne({
                            where:{type:'Whatsapp'}
                        });

                        if(apset.status == 1) {
                            var useRole = await this.useRepo.findOne({
                                where:{Id:savedPostData.userId}
                            })
                            if(useRole && (useRole.roleId == 1 || useRole.roleId == 2) ) { 
                                let currDt = new Date().toJSON().slice(0, 10);
        
                                const postdumrec = await this.pmsgsRepo.findOne({
                                    where:{insDate: currDt},
                                    order:{createdAt: "DESC"}
                                });

                                let [whatsids, grpcount] = await this.whatgrpRepo.findAndCount({
                                    where:{status:1},
                                    order:{Id:'ASC'}
                                });
                                
                                var udata = [];
                                var udataids = [];
        
                                if(postdumrec) {
                                    if(postdumrec.remains > 0) {
                                        let newcnt = ++postdumrec.lcount;
                                        let newrm = postdumrec.remains - 500;
                                        let newuid = postdumrec.userId;
                                        let limt = 500;
                                        if(grpcount <= 500)
                                            limt -= grpcount;
                        
                                        whatsids.map((u) => {
                                            udata.push(u.groupId);
                                        });
        
                                        const remUsers = await this.useRepo.find({
                                            where:{status:true,Id:MoreThan(newuid)},
                                            order:{Id:'ASC'},
                                            take: limt
                                        });
        
                                        if(remUsers.length > 0)  {                                            
                                            remUsers.map((u) => {
                                                udata.push(u.mobileNo);
                                                udataids.push(u.Id);
                                            });
                                            
                                            if(udata.length > 0) {
                                                let lastItem = udataids[udataids.length - 1];
                                                limt -= udata.length;
                                                newrm += limt;
                                                var mob = udata.toString();
    
                                                await this.pmsgsRepo.save({
                                                    postId:savedPostData.Id,
                                                    userId: lastItem,
                                                    sent: udata.length,
                                                    remains: newrm,
                                                    lcount: newcnt,
                                                    insDate: currDt
                                                });                                            
    
                                                if(savedPostData.postTypeId == 2) {
                                                    const postImages = await this.postFilesService.getPostFiles(postId, 'image');
                                                    var uimg = [];
                                                    if(postImages) {
                                                        postImages.map((i) => {
                                                            uimg.push(i.fileUrl);                                                    
                                                        })
                                                        var img = `${process.env.WORKINGURL}/${uimg[0]}`;
                                                        var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                        var cap = savedPostData.text ;
                                                        var txt = '';
                                                        var to = mob;
                                                        this.sendWhatsAppImg(img,cap,txt,to);
                                                    } 
                                                    
                                                }    
                                                
                                                if(savedPostData.postTypeId == 3) {
                                                    const postVideos = await this.postFilesService.getPostFiles(postId,'video');
                                                    var uimg = [];
                                                    if(postVideos) {
                                                        postVideos.map((i) => {
                                                            uimg.push(i.fileUrl);                                                    
                                                        })
        
                                                        var img = `${process.env.WORKINGURL}/${uimg[0]}`;
                                                        var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                        var cap = savedPostData.text ;
                                                        var txt = '';
                                                        var to = mob;
                                                        this.sendWhatsAppVideo(img,cap,txt,to);
                                                    }                                                
                                                }
                                            } 
                                        } else {
                                            const remnUsers = await this.useRepo.find({
                                                where:{status:true},
                                                order:{Id:'ASC'},
                                                take: limt
                                            });
            
                                            if(remnUsers.length > 0)  {
                                                
                                                remnUsers.map((u) => {
                                                    udata.push(u.mobileNo);
                                                    udataids.push(u.Id);
                                                });
                                                
                                                if(udata.length > 0) {
                                                    let lastItem = udataids[udataids.length - 1];
                                                    limt -= udata.length;
                                                    newrm += limt;
                                                    var mob = udata.toString();
        
                                                    await this.pmsgsRepo.save({
                                                        postId:savedPostData.Id,
                                                        userId: lastItem,
                                                        sent: udata.length,
                                                        remains: newrm,
                                                        lcount: newcnt,
                                                        insDate: currDt
                                                    });                                            
        
                                                    if(savedPostData.postTypeId == 2) {
                                                        const postImages = await this.postFilesService.getPostFiles(postId, 'image');
                                                        var uimg = [];
                                                        if(postImages) {
                                                            postImages.map((i) => {
                                                                uimg.push(i.fileUrl);                                                    
                                                            })
                                                            var img = `${process.env.WORKINGURL}/${uimg[0]}`;
                                                            var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                            var cap = savedPostData.text ;
                                                            var txt = '';
                                                            var to = mob;
                                                            this.sendWhatsAppImg(img,cap,txt,to);
                                                        } 
                                                        
                                                    }    
                                                    
                                                    if(savedPostData.postTypeId == 3) {
                                                        const postVideos = await this.postFilesService.getPostFiles(postId,'video');
                                                        var uimg = [];
                                                        if(postVideos) {
                                                            postVideos.map((i) => {
                                                                uimg.push(i.fileUrl);                                                    
                                                            })
            
                                                            var img = `${process.env.WORKINGURL}/${uimg[0]}`;
                                                            var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                            var cap = savedPostData.text ;
                                                            var txt = '';
                                                            var to = mob;
                                                            this.sendWhatsAppVideo(img,cap,txt,to);
                                                        }                                                
                                                    }
                                                } 
                                            }
                                        }                                
                                    }
                                } else {
                                    const postdumrec1 = await this.pmsgsRepo.findOne({
                                        order:{createdAt: "DESC"}
                                    });
                                    if(postdumrec1) {
                                        let newcnt = 1;
                                        let newrm = 4000;
                                        let newuid = postdumrec1.userId;
                                        let limt = 500;
                                        if(grpcount <= 500)
                                            limt -= grpcount;
                        
                                        whatsids.map((u) => {
                                            udata.push(u.groupId);
                                        });
                                        const remUsers = await this.useRepo.find({
                                            where:{status:true,Id:MoreThan(newuid)},
                                            order:{Id:'ASC'},
                                            take: limt
                                        });
        
                                        if(remUsers.length > 0)  {
                                            
                                            remUsers.map((u) => {
                                                udata.push(u.mobileNo);
                                                udataids.push(u.Id);
                                            });
                                            
                                            if(udata.length > 0) {
                                                let lastItem = udataids[udataids.length - 1];
                                                limt -= udata.length;
                                                newrm += limt;
                                                var mob = udata.toString();
                                                
                                                await this.pmsgsRepo.save({
                                                    postId:savedPostData.Id,
                                                    userId: lastItem,
                                                    sent: udata.length,
                                                    remains: newrm,
                                                    lcount: newcnt,
                                                    insDate: currDt
                                                });                                            
    
                                                if(savedPostData.postTypeId == 2) {
                                                    const postImages = await this.postFilesService.getPostFiles(postId, 'image');
                                                    var uimg = [];
                                                    if(postImages) {
                                                        postImages.map((i) => {
                                                            uimg.push(i.fileUrl);                                                    
                                                        })
                                                        var img = `${process.env.WORKINGURL}/${uimg[0]}`;
                                                        var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                        var cap = savedPostData.text ;
                                                        var txt = '';
                                                        var to = mob;
                                                        this.sendWhatsAppImg(img,cap,txt,to);
                                                    } 
                                                    
                                                }    
                                                
                                                if(savedPostData.postTypeId == 3) {
                                                    const postVideos = await this.postFilesService.getPostFiles(postId,'video');
                                                    var uimg = [];
                                                    if(postVideos) {
                                                        postVideos.map((i) => {
                                                            uimg.push(i.fileUrl);                                                    
                                                        })
        
                                                        var img = `${process.env.WORKINGURL}/${uimg[0]}`;
                                                        var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                        var cap = savedPostData.text ;
                                                        var txt = '';
                                                        var to = mob;
                                                        this.sendWhatsAppVideo(img,cap,txt,to);
                                                    }                                                
                                                }
                                                
                                            } 
                                        } else {
                                            const remnUsers = await this.useRepo.find({
                                                where:{status:true},
                                                order:{Id:'ASC'},
                                                take: limt
                                            });
            
                                            if(remnUsers.length > 0)  {
                                               
                                                remnUsers.map((u) => {
                                                    udata.push(u.mobileNo);
                                                    udataids.push(u.Id);
                                                });
                                                
                                                if(udata.length > 0) {
                                                    let lastItem = udataids[udataids.length - 1];
                                                    limt -= udata.length;
                                                    newrm += limt;
                                                    var mob = udata.toString();
                                                    
                                                    await this.pmsgsRepo.save({
                                                        postId:savedPostData.Id,
                                                        userId: lastItem,
                                                        sent: udata.length,
                                                        remains: newrm,
                                                        lcount: newcnt,
                                                        insDate: currDt
                                                    });                                            
        
                                                    if(savedPostData.postTypeId == 2) {
                                                        const postImages = await this.postFilesService.getPostFiles(postId, 'image');
                                                        var uimg = [];
                                                        if(postImages) {
                                                            postImages.map((i) => {
                                                                uimg.push(i.fileUrl);                                                    
                                                            })
                                                            var img = `${process.env.WORKINGURL}/${uimg[0]}`;
                  
                                                            var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                            var cap = savedPostData.text ;
                                                            var txt = '';
                                                            var to = mob;
                                                            this.sendWhatsAppImg(img,cap,txt,to);
                                                        } 
                                                        
                                                    }    
                                                    
                                                    if(savedPostData.postTypeId == 3) {
                                                        const postVideos = await this.postFilesService.getPostFiles(postId,'video');
                                                        var uimg = [];
                                                        if(postVideos) {
                                                            postVideos.map((i) => {
                                                                uimg.push(i.fileUrl);                                                    
                                                            })
            
                                                            var img = `${process.env.WORKINGURL}/${uimg[0]}`;
                                                            var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                            var cap = savedPostData.text ;
                                                            var txt = '';
                                                            var to = mob;
                                                            this.sendWhatsAppVideo(img,cap,txt,to);
                                                        }                                                
                                                    }
                                                    
                                                } 
                                            }
                                        }                                
                                    } else {
                                        let newcnt = 1;
                                        let newrm = 4000;
                                        let limt = 500;
                                        if(grpcount <= 500)
                                            limt -= grpcount;
                        
                                        whatsids.map((u) => {
                                            udata.push(u.groupId);
                                        });
                                        
                                        const remUsers = await this.useRepo.find({
                                            where:{status:true},
                                            order:{Id:'ASC'},
                                            take: limt
                                        });
        
                                        if(remUsers.length > 0)  {                                            
                                            remUsers.map((u) => {
                                                udata.push(u.mobileNo);
                                                udataids.push(u.Id);
                                            });
                                            
                                            if(udata.length > 0) {
                                                let lastItem = udataids[udataids.length - 1];
                                                limt -= udata.length;
                                                newrm += limt;
                                                var mob = udata.toString();
                                                
                                                await this.pmsgsRepo.save({
                                                    postId:savedPostData.Id,
                                                    userId: lastItem,
                                                    sent: udata.length,
                                                    remains: newrm,
                                                    lcount: newcnt,
                                                    insDate: currDt
                                                });                                            
    
                                                if(savedPostData.postTypeId == 2) {
                                                    const postImages = await this.postFilesService.getPostFiles(postId, 'image');
                                                    var uimg = [];
                                                    if(postImages) {
                                                        postImages.map((i) => {
                                                            uimg.push(i.fileUrl);                                                    
                                                        })
                                                        var img = `${process.env.WORKINGURL}/${uimg[0]}`;
                                                        var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                        var cap = savedPostData.text ;
                                                        var txt = '';
                                                        var to = mob;
                                                        this.sendWhatsAppImg(img,cap,txt,to);
                                                    } 
                                                    
                                                }    
                                                
                                                if(savedPostData.postTypeId == 3) {
                                                    const postVideos = await this.postFilesService.getPostFiles(postId,'video');
                                                    var uimg = [];
                                                    if(postVideos) {
                                                        postVideos.map((i) => {
                                                            uimg.push(i.fileUrl);                                                    
                                                        })
        
                                                        var img = `${process.env.WORKINGURL}/${uimg[0]}`;
                                                        var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                        var cap = savedPostData.text ;
                                                        var txt = '';
                                                        var to = mob;
                                                        this.sendWhatsAppVideo(img,cap,txt,to);
                                                    }                                                
                                                }
                                                
                                            } 
                                        }                                 
                                    }
        
                                }
                                
                            }  
                        }
                                
                        response.status = true;
                        response.data   = savedPostData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Post Created Successfully';
                        response.intlCode = 11100;
                    } else { 
                        throw new ErrorResponse(11106, 'Post Not Saved')
                    }               
                } else {
                    throw new ErrorResponse(11106,'Post saved but issue while uploading image/video');
                }
            } else {
                let images: any[] = [];
                const fileUpload = await this.postFilesService.createPostAttachments(filesData);
                if(fileUpload) {
                    const savedPostData = await this.postRepository.findOne({
                        relations:['posttype','postfiles'],
                        where:{Id:postId}
                    });
                    if(savedPostData) {
                        var apset = await this.apsetRepo.findOne({
                            where:{type:'Whatsapp'}
                        });

                        if(apset.status == 1) {
                            var useRole = await this.useRepo.findOne({
                                where:{Id:savedPostData.userId}
                            })
                            if(useRole && (useRole.roleId == 1 || useRole.roleId == 2) ) { 
                                let currDt = new Date().toJSON().slice(0, 10);
        
                                const postdumrec = await this.pmsgsRepo.findOne({
                                    where:{insDate: currDt},
                                    order:{createdAt: "DESC"}
                                });

                                let [whatsids, grpcount] = await this.whatgrpRepo.findAndCount({
                                    where:{status:1},
                                    order:{Id:'ASC'}
                                });
                                
                                var udata = [];
                                var udataids = [];
        
                                if(postdumrec) {
                                    if(postdumrec.remains > 0) {
                                        let newcnt = ++postdumrec.lcount;
                                        let newrm = postdumrec.remains - 500;
                                        let newuid = postdumrec.userId;
                                        let limt = 500;
                                        if(grpcount <= 500)
                                            limt -= grpcount;
                        
                                        whatsids.map((u) => {
                                            udata.push(u.groupId);
                                        });
        
                                        const remUsers = await this.useRepo.find({
                                            where:{status:true,Id:MoreThan(newuid)},
                                            order:{Id:'ASC'},
                                            take: limt
                                        });
        
                                        if(remUsers.length > 0)  {                                            
                                            remUsers.map((u) => {
                                                udata.push(u.mobileNo);
                                                udataids.push(u.Id);
                                            });
                                            
                                            if(udata.length > 0) {
                                                let lastItem = udataids[udataids.length - 1];
                                                limt -= udata.length;
                                                newrm += limt;
                                                var mob = udata.toString();
    
                                                await this.pmsgsRepo.save({
                                                    postId:savedPostData.Id,
                                                    userId: lastItem,
                                                    sent: udata.length,
                                                    remains: newrm,
                                                    lcount: newcnt,
                                                    insDate: currDt
                                                });                                            
    
                                                if(savedPostData.postTypeId == 2) {
                                                    const postImages = await this.postFilesService.getPostFiles(postId, 'image');
                                                    var uimg = [];
                                                    if(postImages) {
                                                        postImages.map((i) => {
                                                            uimg.push(i.fileUrl);                                                    
                                                        })
                                                        var img = `${process.env.WORKINGURL}/${uimg[0]}`;
                                                        var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                        var cap = savedPostData.text ;
                                                        var txt = '';
                                                        var to = mob;
                                                        this.sendWhatsAppImg(img,cap,txt,to);
                                                    } 
                                                    
                                                }    
                                                
                                                if(savedPostData.postTypeId == 3) {
                                                    const postVideos = await this.postFilesService.getPostFiles(postId,'video');
                                                    var uimg = [];
                                                    if(postVideos) {
                                                        postVideos.map((i) => {
                                                            uimg.push(i.fileUrl);                                                    
                                                        })
        
                                                        var img = `${process.env.WORKINGURL}/${uimg[0]}`;
                                                        var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                        var cap = savedPostData.text ;
                                                        var txt = '';
                                                        var to = mob;
                                                        this.sendWhatsAppVideo(img,cap,txt,to);
                                                    }                                                
                                                }
                                            } 
                                        } else {
                                            const remnUsers = await this.useRepo.find({
                                                where:{status:true},
                                                order:{Id:'ASC'},
                                                take: limt
                                            });
            
                                            if(remnUsers.length > 0)  {
                                                
                                                remnUsers.map((u) => {
                                                    udata.push(u.mobileNo);
                                                    udataids.push(u.Id);
                                                });
                                                
                                                if(udata.length > 0) {
                                                    let lastItem = udataids[udataids.length - 1];
                                                    limt -= udata.length;
                                                    newrm += limt;
                                                    var mob = udata.toString();
        
                                                    await this.pmsgsRepo.save({
                                                        postId:savedPostData.Id,
                                                        userId: lastItem,
                                                        sent: udata.length,
                                                        remains: newrm,
                                                        lcount: newcnt,
                                                        insDate: currDt
                                                    });                                            
        
                                                    if(savedPostData.postTypeId == 2) {
                                                        const postImages = await this.postFilesService.getPostFiles(postId, 'image');
                                                        var uimg = [];
                                                        if(postImages) {
                                                            postImages.map((i) => {
                                                                uimg.push(i.fileUrl);                                                    
                                                            })
                                                            var img = `${process.env.WORKINGURL}/${uimg[0]}`;
                                                            var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                            var cap = savedPostData.text ;
                                                            var txt = '';
                                                            var to = mob;
                                                            this.sendWhatsAppImg(img,cap,txt,to);
                                                        } 
                                                        
                                                    }    
                                                    
                                                    if(savedPostData.postTypeId == 3) {
                                                        const postVideos = await this.postFilesService.getPostFiles(postId,'video');
                                                        var uimg = [];
                                                        if(postVideos) {
                                                            postVideos.map((i) => {
                                                                uimg.push(i.fileUrl);                                                    
                                                            })
            
                                                            var img = `${process.env.WORKINGURL}/${uimg[0]}`;
                                                            var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                            var cap = savedPostData.text ;
                                                            var txt = '';
                                                            var to = mob;
                                                            this.sendWhatsAppVideo(img,cap,txt,to);
                                                        }                                                
                                                    }
                                                } 
                                            }
                                        }                                
                                    }
                                } else {
                                    const postdumrec1 = await this.pmsgsRepo.findOne({
                                        order:{createdAt: "DESC"}
                                    });
                                    if(postdumrec1) {
                                        let newcnt = 1;
                                        let newrm = 4000;
                                        let newuid = postdumrec1.userId;
                                        let limt = 500;
                                        if(grpcount <= 500)
                                            limt -= grpcount;
                        
                                        whatsids.map((u) => {
                                            udata.push(u.groupId);
                                        });
                                        const remUsers = await this.useRepo.find({
                                            where:{status:true,Id:MoreThan(newuid)},
                                            order:{Id:'ASC'},
                                            take: limt
                                        });
        
                                        if(remUsers.length > 0)  {
                                            
                                            remUsers.map((u) => {
                                                udata.push(u.mobileNo);
                                                udataids.push(u.Id);
                                            });
                                            
                                            if(udata.length > 0) {
                                                let lastItem = udataids[udataids.length - 1];
                                                limt -= udata.length;
                                                newrm += limt;
                                                var mob = udata.toString();
                                                
                                                await this.pmsgsRepo.save({
                                                    postId:savedPostData.Id,
                                                    userId: lastItem,
                                                    sent: udata.length,
                                                    remains: newrm,
                                                    lcount: newcnt,
                                                    insDate: currDt
                                                });                                            
    
                                                if(savedPostData.postTypeId == 2) {
                                                    const postImages = await this.postFilesService.getPostFiles(postId, 'image');
                                                    var uimg = [];
                                                    if(postImages) {
                                                        postImages.map((i) => {
                                                            uimg.push(i.fileUrl);                                                    
                                                        })
                                                        var img = `${process.env.WORKINGURL}/${uimg[0]}`;
                                                        var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                        var cap = savedPostData.text ;
                                                        var txt = '';
                                                        var to = mob;
                                                        this.sendWhatsAppImg(img,cap,txt,to);
                                                    } 
                                                    
                                                }    
                                                
                                                if(savedPostData.postTypeId == 3) {
                                                    const postVideos = await this.postFilesService.getPostFiles(postId,'video');
                                                    var uimg = [];
                                                    if(postVideos) {
                                                        postVideos.map((i) => {
                                                            uimg.push(i.fileUrl);                                                    
                                                        })
        
                                                        var img = `${process.env.WORKINGURL}/${uimg[0]}`;
                                                        var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                        var cap = savedPostData.text ;
                                                        var txt = '';
                                                        var to = mob;
                                                        this.sendWhatsAppVideo(img,cap,txt,to);
                                                    }                                                
                                                }
                                                
                                            } 
                                        } else {
                                            const remnUsers = await this.useRepo.find({
                                                where:{status:true},
                                                order:{Id:'ASC'},
                                                take: limt
                                            });
            
                                            if(remnUsers.length > 0)  {
                                               
                                                remnUsers.map((u) => {
                                                    udata.push(u.mobileNo);
                                                    udataids.push(u.Id);
                                                });
                                                
                                                if(udata.length > 0) {
                                                    let lastItem = udataids[udataids.length - 1];
                                                    limt -= udata.length;
                                                    newrm += limt;
                                                    var mob = udata.toString();
                                                    
                                                    await this.pmsgsRepo.save({
                                                        postId:savedPostData.Id,
                                                        userId: lastItem,
                                                        sent: udata.length,
                                                        remains: newrm,
                                                        lcount: newcnt,
                                                        insDate: currDt
                                                    });                                            
        
                                                    if(savedPostData.postTypeId == 2) {
                                                        const postImages = await this.postFilesService.getPostFiles(postId, 'image');
                                                        var uimg = [];
                                                        if(postImages) {
                                                            postImages.map((i) => {
                                                                uimg.push(i.fileUrl);                                                    
                                                            })
                                                            var img = `${process.env.WORKINGURL}/${uimg[0]}`;
                  
                                                            var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                            var cap = savedPostData.text ;
                                                            var txt = '';
                                                            var to = mob;
                                                            this.sendWhatsAppImg(img,cap,txt,to);
                                                        } 
                                                        
                                                    }    
                                                    
                                                    if(savedPostData.postTypeId == 3) {
                                                        const postVideos = await this.postFilesService.getPostFiles(postId,'video');
                                                        var uimg = [];
                                                        if(postVideos) {
                                                            postVideos.map((i) => {
                                                                uimg.push(i.fileUrl);                                                    
                                                            })
            
                                                            var img = `${process.env.WORKINGURL}/${uimg[0]}`;
                                                            var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                            var cap = savedPostData.text ;
                                                            var txt = '';
                                                            var to = mob;
                                                            this.sendWhatsAppVideo(img,cap,txt,to);
                                                        }                                                
                                                    }
                                                    
                                                } 
                                            }
                                        }                                
                                    } else {
                                        let newcnt = 1;
                                        let newrm = 4000;
                                        let limt = 500;
                                        if(grpcount <= 500)
                                            limt -= grpcount;
                        
                                        whatsids.map((u) => {
                                            udata.push(u.groupId);
                                        });
                                        
                                        const remUsers = await this.useRepo.find({
                                            where:{status:true},
                                            order:{Id:'ASC'},
                                            take: limt
                                        });
        
                                        if(remUsers.length > 0)  {                                            
                                            remUsers.map((u) => {
                                                udata.push(u.mobileNo);
                                                udataids.push(u.Id);
                                            });
                                            
                                            if(udata.length > 0) {
                                                let lastItem = udataids[udataids.length - 1];
                                                limt -= udata.length;
                                                newrm += limt;
                                                var mob = udata.toString();
                                                
                                                await this.pmsgsRepo.save({
                                                    postId:savedPostData.Id,
                                                    userId: lastItem,
                                                    sent: udata.length,
                                                    remains: newrm,
                                                    lcount: newcnt,
                                                    insDate: currDt
                                                });                                            
    
                                                if(savedPostData.postTypeId == 2) {
                                                    const postImages = await this.postFilesService.getPostFiles(postId, 'image');
                                                    var uimg = [];
                                                    if(postImages) {
                                                        postImages.map((i) => {
                                                            uimg.push(i.fileUrl);                                                    
                                                        })
                                                        var img = `${process.env.WORKINGURL}/${uimg[0]}`;
                                                        var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                        var cap = savedPostData.text ;
                                                        var txt = '';
                                                        var to = mob;
                                                        this.sendWhatsAppImg(img,cap,txt,to);
                                                    } 
                                                    
                                                }    
                                                
                                                if(savedPostData.postTypeId == 3) {
                                                    const postVideos = await this.postFilesService.getPostFiles(postId,'video');
                                                    var uimg = [];
                                                    if(postVideos) {
                                                        postVideos.map((i) => {
                                                            uimg.push(i.fileUrl);                                                    
                                                        })
        
                                                        var img = `${process.env.WORKINGURL}/${uimg[0]}`;
                                                        var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                                                        var cap = savedPostData.text ;
                                                        var txt = '';
                                                        var to = mob;
                                                        this.sendWhatsAppVideo(img,cap,txt,to);
                                                    }                                                
                                                }
                                                
                                            } 
                                        }                                 
                                    }
        
                                }
                                
                            }  
                        }
                                
                        response.status = true;
                        response.data   = savedPostData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Post Created Successfully';
                        response.intlCode = 11100;
                    } else { 
                        throw new ErrorResponse(11106, 'Post Not Saved')
                    }               
                } else {
                    throw new ErrorResponse(11106,'Post saved but issue while uploading image/video');
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async editPostAttachments(queryParam, filesData, pollData, postId,userId,vFlag):Promise<PostResponseModel> {
        const response = new PostResponseModel();
        try {
            let images: any[] = [];
            let videos: any[] = [];
            let finPollData: any[] =[];
            if(queryParam.apiVersion == 1) {
                const getOldFiles = await this.postFilesService.getPostFilesById(postId);
                if(getOldFiles) {
                    getOldFiles.map((f) => {
                        var fname = f.fileUrl.split('/')[2];
                        fs.unlinkSync('./public/postFiles/'+fname);
                    })
                    await this.postFilesService.deleteFiles(postId);
                }
                const fileUpload = await this.postFilesService.createPostAttachments(filesData);
                if(pollData.length > 0) {
                    await this.pollService.deletePostPoll(postId);   
                    var dataToPost = pollData.pollOptions.map((el) => {
                        return {
                            postId:postId,
                            userId:userId,
                            pollType: 'text',
                            pollValue: el,
                            createdUser:userId,
                            versionFlag:vFlag
                        };
                    });              
                    const pollAdd = await this.pollService.createPostPoll(dataToPost);
                }
                var post = await this.postRepository.findOne({
                    relations:['village'],
                    where:{Id:postId}
                });                     
                if(!post) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const user = await this.profileService.getUserByUId(post.userId);
                const ldfCount = await this.postActService.getPostLikDisLikFavCount(post.Id);
                const cmtCount =  await this.cmntService.getPostCmtsCount(post.Id);
                const ldfStatus = await this.postActService.getPostLikDisLikFavStatus(post.Id,userId);
                const postImages = await this.postFilesService.getPostFiles(post.Id, 'image');
                const postVideos = await this.postFilesService.getPostFiles(post.Id,'video');
                const postPoll  = await this.pollService.getPostPoll(post.Id);
                const postCategory = await this.postCategoryRepo.findOne({where:{Id:post.postCategoryId}});
                if(postPoll.length > 0) {
                    const pollTotal = await getConnection()
                    .createQueryBuilder()
                    .select("count(*) as cnt")
                    .from(PollVotingEntity, "PollVoting")
                    .where('post_id=:da', { da: post.Id })
                    .orderBy('status','ASC')
                    .getRawOne();
                    const tlCount = pollTotal.cnt;
                    const promises = postPoll.map(async (v) => {
                        const optionTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: post.Id })
                        .andWhere('poll_id=:pi',{pi:v.Id})
                        .orderBy('status','ASC')
                        .getRawOne();
                        const statusTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: post.Id })
                        .andWhere('poll_id=:pi',{pi:v.Id})
                        .andWhere('user_id=:ui',{ui:userId})
                        .orderBy('status','ASC')
                        .getRawOne();                        
                        return  {
                            pollId:v.Id,
                            pollValue:v.pollValue,
                            pollType:v.pollType,
                            polCnt: optionTotal.cnt,
                            usta: statusTotal.cnt > 0 ? true : false
                        }
                    })
                    const da = await Promise.all(promises);
                    da.map((f) => { 
                        finPollData.push({
                            pollId: f.pollId,
                            pollType:f.pollType,
                            pollValue:f.pollValue,
                            totalCount:tlCount,
                            pollCount:f.polCnt,
                            percentage: tlCount == 0 ? 0 : Math.round(f.polCnt / (tlCount / 100)),
                            userStatus: f.usta
                        })
                    });
                } else {
                    finPollData = [];
                }
                if(postImages) {
                    postImages.map((i) => {
                        images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                    })
                } 
                if(postVideos) { 
                    postVideos.map((v) => {
                        videos.push(`${process.env.WORKINGURL}/${v.fileUrl}`)
                    })
                }
                var day_start = new Date(post.createdAt);
                var day_end = new Date();
                var total_days = (day_end.valueOf() - day_start.valueOf()) / (1000 * 60 * 60 * 24);
                var finalDys = Math.round(total_days);
                if(finalDys == 0) {
                    var minutes = (day_end.valueOf() - day_start.valueOf());
                    var finalMins = Math.round(((minutes % 86400000) % 3600000) / 60000);
                }
                if(post.pollExpire != null) {
                    var day_start1 = new Date();
                    var day_end1 = new Date(post.pollExpire);
                    var total_days1 = (day_end1.valueOf() - day_start1.valueOf()) / (1000 * 60 * 60 * 24);
                    var finalDys1 = Math.round(total_days1);
                    if(finalDys1 == 0) {
                        var minutes1 = (day_end1.valueOf() - day_start1.valueOf());
                        var finalMins1 = Math.round(((minutes1 % 86400000) % 3600000) / 60000);
                    }
                } else {
                    var finalDys1 = 0;
                    var finalMins1 = 0;
                }
                let final = {
                    postId:post.Id,
                    isDevelopmentPost:post.isDevelopmentPost == 1?true:false,
                    text:post.text,
                    postDays:finalDys == 0?finalMins+ ' minutes ago':finalDys+' day(s) ago',
                    postTime:post.createdAt,
                    postTypeId:post.postTypeId,
                    postCategoryId:post.postCategoryId,
                    postCategoryName:postCategory != undefined? postCategory.postcategory : '',
                    villageId:post.villageId,
                    villageName:post.village != null? post.village.villageName:'',
                    userId:post.userId,
                    userName: user.firstName != null ? user.firstName :'',
                    profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
                    likesCount:ldfCount.likesCount != null ? `${ldfCount.likesCount}` : 0,
                    likeStatus:ldfStatus != null ? ldfStatus.like : false,
                    disLikesCount:ldfCount.disLikesCount !=null ? `${ldfCount.disLikesCount}` : 0,
                    disLikeStatus:ldfStatus != null ? ldfStatus.dislike : false,
                    favCount:ldfCount.favCount != null ? `${ldfCount.favCount}` : 0,
                    favStatus:ldfStatus != null ? ldfStatus.fev : false,
                    commentCount:cmtCount.cnt != null ? cmtCount.cnt : 0,
                    postImages:images,
                    postVideos:videos,
                    poll:finPollData,
                    pollExpire:finalDys1 == 0?finalMins1+ ' minutes':finalDys1+' day(s)',
                    viewCount:post.viewCount
                }
                response.status = true;
                response.data   = final;
                response.statusCode = 50000;
                response.internalMessage = 'Post Edited Successfully';
                response.intlCode = 11100;                
            } else {
                const getOldFiles = await this.postFilesService.getPostFilesById(postId);
                if(getOldFiles) {
                    getOldFiles.map((f) => {
                        var fname = f.fileUrl.split('/')[2];
                        fs.unlinkSync('./public/postFiles/'+fname);
                    })
                    await this.postFilesService.deleteFiles(postId);
                }
                const fileUpload = await this.postFilesService.createPostAttachments(filesData);
                if(pollData.length > 0) {
                    await this.pollService.deletePostPoll(postId);   
                    var dataToPost = pollData.pollOptions.map((el) => {
                        return {
                            postId:postId,
                            userId:userId,
                            pollType: 'text',
                            pollValue: el,
                            createdUser:userId,
                            versionFlag:vFlag
                        };
                    });              
                    const pollAdd = await this.pollService.createPostPoll(dataToPost);
                }
                var post = await this.postRepository.findOne({
                    relations:['village'],
                    where:{Id:postId}
                });                     
                if(!post) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const user = await this.profileService.getUserByUId(post.userId);
                const ldfCount = await this.postActService.getPostLikDisLikFavCount(post.Id);
                const cmtCount =  await this.cmntService.getPostCmtsCount(post.Id);
                const ldfStatus = await this.postActService.getPostLikDisLikFavStatus(post.Id,userId);
                const postImages = await this.postFilesService.getPostFiles(post.Id, 'image');
                const postVideos = await this.postFilesService.getPostFiles(post.Id,'video');
                const postPoll  = await this.pollService.getPostPoll(post.Id);
                const postCategory = await this.postCategoryRepo.findOne({where:{Id:post.postCategoryId}});
                if(postPoll.length > 0) {
                    const pollTotal = await getConnection()
                    .createQueryBuilder()
                    .select("count(*) as cnt")
                    .from(PollVotingEntity, "PollVoting")
                    .where('post_id=:da', { da: post.Id })
                    .orderBy('status','ASC')
                    .getRawOne();
                    const tlCount = pollTotal.cnt;
                    const promises = postPoll.map(async (v) => {
                        const optionTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: post.Id })
                        .andWhere('poll_id=:pi',{pi:v.Id})
                        .orderBy('status','ASC')
                        .getRawOne();
                        const statusTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: post.Id })
                        .andWhere('poll_id=:pi',{pi:v.Id})
                        .andWhere('user_id=:ui',{ui:userId})
                        .orderBy('status','ASC')
                        .getRawOne();                        
                        return  {
                            pollId:v.Id,
                            pollValue:v.pollValue,
                            pollType:v.pollType,
                            polCnt: optionTotal.cnt,
                            usta: statusTotal.cnt > 0 ? true : false
                        }
                    })
                    const da = await Promise.all(promises);
                    da.map((f) => { 
                        finPollData.push({
                            pollId: f.pollId,
                            pollType:f.pollType,
                            pollValue:f.pollValue,
                            totalCount:tlCount,
                            pollCount:f.polCnt,
                            percentage: tlCount == 0 ? 0 : Math.round(f.polCnt / (tlCount / 100)),
                            userStatus: f.usta
                        })
                    });
                } else {
                    finPollData = [];
                }
                if(postImages) {
                    postImages.map((i) => {
                        images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                    })
                } 
                if(postVideos) { 
                    postVideos.map((v) => {
                        videos.push(`${process.env.WORKINGURL}/${v.fileUrl}`)
                    })
                }
                var day_start = new Date(post.createdAt);
                var day_end = new Date();
                var total_days = (day_end.valueOf() - day_start.valueOf()) / (1000 * 60 * 60 * 24);
                var finalDys = Math.round(total_days);
                if(finalDys == 0) {
                    var minutes = (day_end.valueOf() - day_start.valueOf());
                    var finalMins = Math.round(((minutes % 86400000) % 3600000) / 60000);
                }
                if(post.pollExpire != null) {
                    var day_start1 = new Date();
                    var day_end1 = new Date(post.pollExpire);
                    var total_days1 = (day_end1.valueOf() - day_start1.valueOf()) / (1000 * 60 * 60 * 24);
                    var finalDys1 = Math.round(total_days1);
                    if(finalDys1 == 0) {
                        var minutes1 = (day_end1.valueOf() - day_start1.valueOf());
                        var finalMins1 = Math.round(((minutes1 % 86400000) % 3600000) / 60000);
                    }
                } else {
                    var finalDys1 = 0;
                    var finalMins1 = 0;
                }
                let final = {
                    postId:post.Id,
                    isDevelopmentPost:post.isDevelopmentPost == 1?true:false,
                    text:post.text,
                    postDays:finalDys == 0?finalMins+ ' minutes ago':finalDys+' day(s) ago',
                    postTime:post.createdAt,
                    postTypeId:post.postTypeId,
                    postCategoryId:post.postCategoryId,
                    postCategoryName:postCategory != undefined? postCategory.postcategory : '',
                    villageId:post.villageId,
                    villageName:post.village != null? post.village.villageName:'',
                    userId:post.userId,
                    userName: user.firstName != null ? user.firstName :'',
                    profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
                    likesCount:ldfCount.likesCount != null ? `${ldfCount.likesCount}` : 0,
                    likeStatus:ldfStatus != null ? ldfStatus.like : false,
                    disLikesCount:ldfCount.disLikesCount !=null ? `${ldfCount.disLikesCount}` : 0,
                    disLikeStatus:ldfStatus != null ? ldfStatus.dislike : false,
                    favCount:ldfCount.favCount != null ? `${ldfCount.favCount}` : 0,
                    favStatus:ldfStatus != null ? ldfStatus.fev : false,
                    commentCount:cmtCount.cnt != null ? cmtCount.cnt : 0,
                    postImages:images,
                    postVideos:videos,
                    poll:finPollData,
                    pollExpire:finalDys1 == 0?finalMins1+ ' minutes':finalDys1+' day(s)',
                    viewCount:post.viewCount
                }
                response.status = true;
                response.data   = final;
                response.statusCode = 50000;
                response.internalMessage = 'Post Edited Successfully';
                response.intlCode = 11100;              
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async createPostPoll(queryParam, dataToPost,postId):Promise<PostResponseModel> {
        const response = new PostResponseModel();
        try {
            if(queryParam.apiVersion == 1) {
                const pollAdd = await this.pollService.createPostPoll(dataToPost);
                if(pollAdd) {
                    const savedPostData = await this.postRepository.findOne({
                        relations:['posttype','poll'],
                        where:{Id:postId}
                    });
                    if(savedPostData) {
                        response.status = true;
                        response.data   = savedPostData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Post Created Successfully';
                        response.intlCode = 11100;
                    } else { 
                        throw new ErrorResponse(11106, 'Post Not Saved')
                    }               
                } else {
                    throw new ErrorResponse(11106,'Post saved but issue while creating poll');
                }
            } else {
                const pollAdd = await this.pollService.createPostPoll(dataToPost);
                if(pollAdd) {
                    const savedPostData = await this.postRepository.findOne({
                        relations:['posttype','poll'],
                        where:{Id:postId}
                    });
                    if(savedPostData) {
                        response.status = true;
                        response.data   = savedPostData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Post Created Successfully';
                        response.intlCode = 11100;
                    } else { 
                        throw new ErrorResponse(11106, 'Post Not Saved')
                    }               
                } else {
                    throw new ErrorResponse(11106,'Post saved but issue while creating poll');
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    
    async pinPost(queryParams,pinPostDto:PinPostDto,request:Request): Promise<SingleResponseModel> {
        const response = new SingleResponseModel();
        try {
            var dt = new Date();                
            if(queryParams.apiVersion == 1) {
                const removeOld = await this.postRepository.update({isPinned:true},{isPinned:false})
                const update = await this.postRepository.update(pinPostDto.postId, {isPinned:pinPostDto.isPinned,pinDate:dt,pinnedBy:pinPostDto.userId})
                if(update) {
                    response.status = true;
                    response.statusCode = 50000;
                    response.internalMessage = 'Post pinned successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Post pin failed')
                }
            } else {
                const removeOld = await this.postRepository.update({isPinned:true},{isPinned:false})
                const update = await this.postRepository.update(pinPostDto.postId, {isPinned:pinPostDto.isPinned,pinDate:dt,pinnedBy:pinPostDto.userId})
                if(update) {
                    response.status = true;
                    response.statusCode = 50000;
                    response.internalMessage = 'Post pinned successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Post pin failed')
                }
            }
            return response;
        } catch(error) {
            throw error;
        }
    }

    async postApproval(queryParams,postApprvDto:PostApprvDto,request:Request): Promise<SingleResponseModel> {
        const response = new SingleResponseModel();
        try {
            var dt = new Date();                
            if(queryParams.apiVersion == 1) {
                const update = await this.postRepository.update(postApprvDto.postId, {status:postApprvDto.status})
                if(update) {
                    response.status = true;
                    response.statusCode = 50000;
                    response.internalMessage = postApprvDto.status==1?'Post approved':'Post unapproved ';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Post approval failed')
                }
            } else {
                const update = await this.postRepository.update(postApprvDto.postId, {status:postApprvDto.status})
                if(update) {
                    response.status = true;
                    response.statusCode = 50000;
                    response.internalMessage = postApprvDto.status==1?'Post approved':'Post unapproved ';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Post approval failed')
                }
            }
            return response;
        } catch(error) {
            throw error;
        }
    }
    
    async getPostByCategory(queryParams, categoryId,request:Request):Promise<AllPostsResponseModel> {
        const response = new AllPostsResponseModel();
        try {
            let images: any[] = [];
            const posts = await this.postRepository.find({
                           where:{status:1,postCategoryId:categoryId},
                            order: {createdAt: "DESC"}
                        });
            if(!posts) {
                    throw new ErrorResponse(99908,'Data not found')
            }
            const promises = posts.map(async (post) => {
                   const postImages = await this.postFilesService.getPostFiles(post.Id, 'image');
                   return {
                        postDate:post.createdAt,
                        postImages:postImages
                    }   
            });
            const da = await Promise.all(promises);
            da.map((f) => {  
                let date = new Date(f.postDate)
                let a = date.getFullYear()
                let b = date.getMonth()+1 // JS months are 0 indexed, 0 = January, 11 = December
                let c = date.getDate()
                let nb = b > 9 ? b : '0'+b;
                let nc = c > 9 ? c : '0'+c;
                let ndt = a+'-'+nb+'-'+nc;

                if(f.postImages) {
                    f.postImages.map((i) => {
                        images.push({
                            postDate:ndt,
                            postUrl:`${process.env.WORKINGURL}/${i.fileUrl}`
                        })
                    });
                }
            });
           response.status = true;
           response.data = images;
           response.statusCode = 50000;
           response.internalMessage = 'Data retrived successfully';
           response.intlCode = 11108;  
           return response;
        } catch(error) {
           throw error;//new ErrorResponse(99998, error);
        }  
    }

    async getActivePosts(pageDto:PaginationDto, userId,request:Request):Promise<AllPostsResponseModel> {
        const response = new AllPostsResponseModel();
        try {
            const finData: any[] = [];
            let finPollData: any[] = []; 
            let images: any[] = [];
            let videos: any[] = [];            
            if(pageDto.apiVersion == 1) {
                if(!pageDto.skip || pageDto.skip == null) {
                    pageDto.skip = 0;
                } 
                if(pageDto.type == 0) {
                    if(pageDto.categoryId > 0) {
                        var posts = await this.postRepository.find({
                            relations:['village'],
                            where:{status:1,isPinned:true,postCategoryId:pageDto.categoryId},
                            order: {pinDate: "DESC"},
                            skip:pageDto.skip,
                            take: 10
                        });
                    } else {
                        var posts = await this.postRepository.find({
                            relations:['village'],
                            where:{status:1,isPinned:true},
                            order: {pinDate: "DESC"},
                            skip:pageDto.skip,
                            take: 10
                        });
                    }
                }
                if(pageDto.type == 1) {
                  if(pageDto.categoryId > 0) {
                    var posts = await this.postRepository.find({
                        where:{status:1,isPinned:false,postCategoryId:pageDto.categoryId},
                        order: {createdAt: "DESC"},
                        skip:pageDto.skip,
                        take: 10
                    });  
                   } else {
                        var posts = await this.postRepository.find({
                        where:{status:1,isPinned:false},
                        order: {createdAt: "DESC"},
                        skip:pageDto.skip,
                        take: 10
                    	});  
                    }                     
                }                    
                if(pageDto.type == 2) {
                    if(pageDto.categoryId > 0) {
                        var posts = await this.postRepository.find({
                            where:{status:1,isDevelopmentPost:0,postCategoryId:pageDto.categoryId},
                            order: {createdAt: "DESC"},
                            skip:pageDto.skip,
                            take: 10
                        }); 
                    } else {
                        var posts = await this.postRepository.find({
                            where:{status:1,isDevelopmentPost:0},
                            order: {createdAt: "DESC"},
                            skip:pageDto.skip,
                            take: 10
                        }); 
                    }
                }
                if(pageDto.type == 3) {
                    if(pageDto.categoryId > 0) {
                        var posts = await this.postRepository
                        .createQueryBuilder("post")
                        .innerJoinAndSelect('post.postactivity','postactivity','postactivity.postId = post.Id')
                        .where('post.status=:da', { da: true })
                        .andWhere('postactivity.fev=:f',{f:true})
                        .andWhere('postactivity.userId=:u',{u:userId})
                        .andWhere('post.postCategoryId=:ci',{ci:pageDto.categoryId})
                        .orderBy('post.createdAt','DESC')
                        .skip(pageDto.skip)
                        .take(10)
                        .getMany(); 
                   } else {
                    var posts = await this.postRepository
                        .createQueryBuilder("post")
                        .innerJoinAndSelect('post.postactivity','postactivity','postactivity.postId = post.Id')
                        .where('post.status=:da', { da: true })
                        .andWhere('postactivity.fev=:f',{f:true})
                        .andWhere('postactivity.userId=:u',{u:userId})
                        .orderBy('post.createdAt','DESC')
                        .skip(pageDto.skip)
                        .take(10)
                        .getMany(); 
                    }      
                }
                if(pageDto.type == 4) {
                    if(pageDto.villageId > 0) { 
                        if(pageDto.filterId == 0) {
                            if(pageDto.categoryId > 0) {
                                var posts = await this.postRepository.find({
                                    where:{status:1,isDevelopmentPost:1,villageId:pageDto.villageId,postCategoryId:pageDto.categoryId},
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            } else {
                                var posts = await this.postRepository.find({
                                    where:{status:1,isDevelopmentPost:1,villageId:pageDto.villageId},
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            }
                        } else if(pageDto.filterId == 1) {
                            var sname = 'new';
                            var sname2 = 'Yet to start';
                            if(pageDto.categoryId > 0) {
                                var posts = await this.postRepository.find({
                                    where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId,postCategoryId:pageDto.categoryId},
                                    {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId,postCategoryId:pageDto.categoryId}],
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            } else {
                                var posts = await this.postRepository.find({
                                    where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId},
                                    {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId}],
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
		                    }
                        } else if(pageDto.filterId == 2) {
                            var sname = 'In Progress';
                            var sname2 = 'InProgress';
                            if(pageDto.categoryId > 0) {
                                var posts = await this.postRepository.find({
                                    where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId,postCategoryId:pageDto.categoryId},
                                    {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId,postCategoryId:pageDto.categoryId}],
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
		                    } else {
                                var posts = await this.postRepository.find({
                                            where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId},
                                            {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId}],
                                            order: {createdAt: "DESC"},
                                            skip:pageDto.skip,
                                            take: 10
                                            });
		                    }
                        } else if(pageDto.filterId == 3) {
                            var sname = 'closed';
                            var sname2 = 'completed';
                            if(pageDto.categoryId > 0) {
                                var posts = await this.postRepository.find({
                                    where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId,postCategoryId:pageDto.categoryId},
                                    {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId,postCategoryId:pageDto.categoryId}],
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            }  else {
                                var posts = await this.postRepository.find({
                                        where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId},
                                        {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId}],
                                        order: {createdAt: "DESC"},
                                        skip:pageDto.skip,
                                        take: 10
                                    });
                            }          
                        
                        } 
                    } else { 
                        if(pageDto.filterId == 0) {
                            if(pageDto.categoryId > 0) {
                                var posts = await this.postRepository.find({
                                    where:{status:1,isDevelopmentPost:1,postCategoryId:pageDto.categoryId},
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            } else {
                                var posts = await this.postRepository.find({
                                    where:{status:1,isDevelopmentPost:1},
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            }
                        } else if(pageDto.filterId == 1) {
                            var sname = 'new';
                            var sname2 = 'Yet to start';
                            if(pageDto.categoryId > 0) {
                                var posts = await this.postRepository.find({
                                    where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,postCategoryId:pageDto.categoryId},
                                    {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,postCategoryId:pageDto.categoryId}],
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            } else {
                                var posts = await this.postRepository.find({
                                    where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1},
                                    {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1}],
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            }
                            
                        } else if(pageDto.filterId == 2) {
                            var sname = 'In Progress';
                            var sname2 = 'InProgress';
                            if(pageDto.categoryId > 0) {
                                var posts = await this.postRepository.find({
                                    where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,postCategoryId:pageDto.categoryId},
                                    {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,postCategoryId:pageDto.categoryId}],
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            } else {
                                var posts = await this.postRepository.find({
                                    where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1},
                                    {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1}],
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            }
                            
                        } else if(pageDto.filterId == 3) {
                            var sname = 'closed';
                            var sname2 = 'completed';
                            if(pageDto.categoryId > 0) {
                            var posts = await this.postRepository.find({
                                    where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,postCategoryId:pageDto.categoryId},
                                    {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,postCategoryId:pageDto.categoryId}],
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            } else {
                            var posts = await this.postRepository.find({
                                    where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1},
                                    {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1}],
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            }
                            
                        }            
                        
                    }                                  
                } 
                if(pageDto.type == 5) {
                    if(pageDto.categoryId > 0) {
                        var posts = await this.postRepository.find({
                            where:{status:1, userId:userId,postCategoryId:pageDto.categoryId},
                            order: {createdAt: "DESC"},
                            skip:pageDto.skip,
                            take: 10
                        });
                    } else {
                    var posts = await this.postRepository.find({
                            where:{status:1, userId:userId},
                            order: {createdAt: "DESC"},
                            skip:pageDto.skip,
                            take: 10
                        });
                    }
                } 
                if(!posts) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const promises = posts.map(async (post) => {
                    const user = await this.profileService.getUserByUId(post.userId);
                    const ldfCount = await this.postActService.getPostLikDisLikFavCount(post.Id);
                    const cmtCount =  await this.cmntService.getPostCmtsCount(post.Id);
                    const ldfStatus = await this.postActService.getPostLikDisLikFavStatus(post.Id,userId);
                    const postImages = await this.postFilesService.getPostFiles(post.Id, 'image');
                    const postVideos = await this.postFilesService.getPostFiles(post.Id,'video');
                    const postPoll  = await this.pollService.getPostPoll(post.Id);
                    const postCategory = await this.postCategoryRepo.findOne({where:{Id:post.postCategoryId}});
                    if(postPoll.length > 0) {
                        const pollTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: post.Id })
                        .orderBy('status','ASC')
                        .getRawOne();
                        const tlCount = pollTotal.cnt;
                        const promises = postPoll.map(async (v) => {
                            const optionTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.Id })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .orderBy('status','ASC')
                            .getRawOne();
                            const statusTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.Id })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .andWhere('user_id=:ui',{ui:userId})
                            .orderBy('status','ASC')
                            .getRawOne();                        
                            return  {
                                pollId:v.Id,
                                pollValue:v.pollValue,
                                pollType:v.pollType,
                                polCnt: optionTotal.cnt,
                                usta: statusTotal.cnt > 0 ? true : false
                            }
                        })
                        const pda = await Promise.all(promises);
                        finPollData =[];
                        pda.map((f) => { 
                            finPollData.push({
                                pollId: f.pollId,
                                pollType:f.pollType,
                                pollValue:f.pollValue,
                                totalCount:tlCount,
                                pollCount:f.polCnt,
                                percentage: tlCount == 0 ? 0 : Math.round(f.polCnt / (tlCount / 100)),
                                userStatus: f.usta
                            })
                        });
                    } else {
                        finPollData =[];
                    }
                    //const loguser = await this.profileService.getUserByUId(userId);
                    return {
                        postId:post.Id,
                        isDevelopmentPost:post.isDevelopmentPost == 1? true:false,
                        text:post.text,
                        postTime:post.createdAt,
                        postTypeId:post.postTypeId,
                        postCategoryId:post.postCategoryId,
                        postCategoryName:postCategory != undefined? postCategory.postcategory : '',
                        villageId:post.villageId,
                        villageName:post.village != null? post.village.villageName:'',
                        userId:post.userId,
                        userName: user.firstName != null ? user.firstName :'',
                        profilePic:user.profilePic,
                        likesCount:ldfCount.likeCount,
                        likeStatus:ldfStatus != null ? ldfStatus.like : false,
                        disLikesCount:ldfCount.dislikeCount,
                        disLikeStatus:ldfStatus != null ? ldfStatus.dislike : false,
                        favCount:ldfCount.fevCount,
                        favStatus:ldfStatus != null ? ldfStatus.fev : false,
                        commentCount:cmtCount.cnt,
                        postImages:postImages,
                        postVideos:postVideos,
                        poll:finPollData,
                        pollExpire:post.pollExpire,
                        viewCount:post.viewCount,
                       // timeOffSet:loguser != null?loguser.user.timeZoneOffset:'00:00'
                    }   
                });   
                const da = await Promise.all(promises);
                da.map((f) => {  
                    if(f.postImages) {
                        f.postImages.map((i) => {
                            images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                        })
                    } 
                    if(f.postVideos) { 
                        f.postVideos.map((v) => {
                            videos.push(`${process.env.WORKINGURL}/${v.fileUrl}`)
                        })
                    }                    
                    var day_start = new Date(f.postTime);
                    var day_end = new Date();
                   // console.log(day_start,day_end)
                    var finalDys = this.timeDiffCalc(day_end,day_start)
                    if(f.pollExpire != null){
                        var day_start1 = new Date();
                        var day_end1 = new Date(f.pollExpire);
                        var finalDys1 = this.timeDiffCalc(day_end1,day_start1)
                    } else {
                        var finalDys1 = '';
                    }
                    
                    finData.push({
                        postId:f.postId,
                        isDevelopmentPost:f.isDevelopmentPost,
                        text:f.text,
                        postDays:finalDys,
                        postTime:f.postTime,
                        postTypeId:f.postTypeId,
                        postCategoryId:f.postCategoryId,
                        postCategoryName:f.postCategoryName,
                        villageId:f.villageId,
                        villageName:f.villageName,
                        userId:f.userId,
                        userName:f.userName,
                        profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
                        likesCount:f.likesCount != null ? `${f.likesCount}` : 0,
                        likeStatus:f.likeStatus,
                        disLikesCount:f.disLikesCount !=null ? `${f.disLikesCount}` : 0,
                        disLikeStatus:f.disLikeStatus,
                        favCount:f.favCount !=null ? `${f.favCount}` : 0,
                        favStatus:f.favStatus,
                        commentCount:f.commentCount !=null ? `${f.commentCount}` : 0,
                        postImages:images,
                        postVideos:videos,
                        poll:f.poll,
                        pollExpire:finalDys1,
                        viewCount:f.viewCount
                    }) 
                    images=[];
                    videos=[];
                }) 
                if(pageDto.type == 4) {                    
                    if(pageDto.villageId > 0) { 
                        var allDevPosts = await this.postRepository.find({
                            where:{status:1,isDevelopmentPost:1,villageId:pageDto.villageId},
                            order: {createdAt: "DESC"}
                        });
                        if(allDevPosts) {
                            var totalDevcnt = allDevPosts.length;
                        } else {
                            var totalDevcnt = 0;
                        }
                        if(totalDevcnt == 0) {
                            response.status = true;
                            response.data = finData;
                            response.percentData = {
                                allCount:totalDevcnt,
                                newCount:0,
                                newPercentage: 0,
                                inProgressCount:0,
                                inProgressPercentage:0,
                                closedCount:0,
                                closedPercentage:0
                            }
                            response.statusCode = 50000;
                            response.internalMessage = 'Data retrived successfully';
                            response.intlCode = 11108;
                        } else {
                            var sname = 'closed';
                            var sname2 = 'completed';
                            var cmptDevPosts = await this.postRepository.find({
                                where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId},
                                {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId}],
                                order: {createdAt: "DESC"}
                            });

                            if(cmptDevPosts) {
                                var cmptDevcnt = cmptDevPosts.length;
                            } else {
                                var cmptDevcnt = 0;
                            }

                            var progressDevPosts = await this.postRepository.find({
                                where: [{developStatus:'in progress',status:1,isDevelopmentPost:1,villageId:pageDto.villageId},
                                {developStatus:'inprogress',status:1,isDevelopmentPost:1,villageId:pageDto.villageId}],
                                order: {createdAt: "DESC"}
                            });                            
                            
                            if(progressDevPosts) {
                                var prgrsDevcnt = progressDevPosts.length;
                            } else {
                                var prgrsDevcnt = 0;
                            }

                            var startDevPosts = await this.postRepository.find({
                                where: [{developStatus:'new',status:1,isDevelopmentPost:1,villageId:pageDto.villageId},
                                {developStatus:'Yet to start',status:1,isDevelopmentPost:1,villageId:pageDto.villageId}],
                                order: {createdAt: "DESC"}
                            });                      

                            if(startDevPosts) {
                                var strtDevcnt = startDevPosts.length;
                            } else {
                                var strtDevcnt = 0;
                            }

                            var strtPer = strtDevcnt == 0? 0 : Math.round((strtDevcnt/totalDevcnt)*100);
                            var inproPer = prgrsDevcnt == 0?0:Math.round((prgrsDevcnt/totalDevcnt)*100);
                            var cmptPer = cmptDevcnt == 0?0:Math.round((cmptDevcnt/totalDevcnt)*100);
                            response.status = true;
                            response.data = finData;
                            response.percentData = {
                                allCount:totalDevcnt,
                                newCount:strtDevcnt,
                                newPercentage: strtPer,
                                inProgressCount:prgrsDevcnt,
                                inProgressPercentage:inproPer,
                                closedCount:cmptDevcnt,
                                closedPercentage:cmptPer
                            }
                            response.statusCode = 50000;
                            response.internalMessage = 'Data retrived successfully';
                            response.intlCode = 11108;
                        }
                    } else { 
                        var allDevPosts = await this.postRepository.find({
                            where:{status:1,isDevelopmentPost:1},
                            order: {createdAt: "DESC"}
                        });
                        if(allDevPosts) {
                            var totalDevcnt = allDevPosts.length;
                        } else {
                            var totalDevcnt = 0;
                        }
                        if(totalDevcnt == 0) {
                            response.status = true;
                            response.data = finData;
                            response.percentData = {
                                allCount:totalDevcnt,
                                newCount:0,
                                newPercentage: 0,
                                inProgressCount:0,
                                inProgressPercentage:0,
                                closedCount:0,
                                closedPercentage:0
                            }
                            response.statusCode = 50000;
                            response.internalMessage = 'Data retrived successfully';
                            response.intlCode = 11108;
                        } else {
                            var sname = 'completed';
                            var sname2 = 'closed';
                            var cmptDevPosts = await this.postRepository.find({
                                where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1},
                                {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1}],
                                order: {createdAt: "DESC"}
                            });

                            if(cmptDevPosts) {
                                var cmptDevcnt = cmptDevPosts.length;
                            } else {
                                var cmptDevcnt = 0;
                            }

                            var progressDevPosts = await this.postRepository.find({
                                where: [{developStatus:'in progress',status:1,isDevelopmentPost:1},
                                {developStatus:'inprogress',status:1,isDevelopmentPost:1}],
                                order: {createdAt: "DESC"}
                            });                            
                            
                            if(progressDevPosts) {
                                var prgrsDevcnt = progressDevPosts.length;
                            } else {
                                var prgrsDevcnt = 0;
                            }

                            var startDevPosts = await this.postRepository.find({
                                where: [{developStatus:'new',status:1,isDevelopmentPost:1},
                                {developStatus:'Yet to start',status:1,isDevelopmentPost:1}],
                                order: {createdAt: "DESC"}
                            });                      

                            if(startDevPosts) {
                                var strtDevcnt = startDevPosts.length;
                            } else {
                                var strtDevcnt = 0;
                            }

                            var strtPer = strtDevcnt == 0? 0 : Math.round((strtDevcnt/totalDevcnt)*100);
                            var inproPer = prgrsDevcnt == 0?0:Math.round((prgrsDevcnt/totalDevcnt)*100);
                            var cmptPer = cmptDevcnt == 0?0:Math.round((cmptDevcnt/totalDevcnt)*100);
                            response.status = true;
                            response.data = finData;
                            response.percentData = {
                                allCount:totalDevcnt,
                                newCount:strtDevcnt,
                                newPercentage: strtPer,
                                inProgressCount:prgrsDevcnt,
                                inProgressPercentage:inproPer,
                                closedCount:cmptDevcnt,
                                closedPercentage:cmptPer
                            }
                            response.statusCode = 50000;
                            response.internalMessage = 'Data retrived successfully';
                            response.intlCode = 11108;
                        }
                    }
                } else {
                    if(finData.length > 0) { 
                        response.status = true;
                        response.data = finData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Data retrieved successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Data not found');
                    }
                } 
            } else {
                if(!pageDto.skip || pageDto.skip == null) {
                    pageDto.skip = 0;
                } 
                if(pageDto.type == 0) {
                    if(pageDto.categoryId > 0) {
                        var posts = await this.postRepository.find({
                            relations:['village'],
                            where:{status:1,isPinned:true,postCategoryId:pageDto.categoryId},
                            order: {pinDate: "DESC"},
                            skip:pageDto.skip,
                            take: 10
                        });
                    } else {
                        var posts = await this.postRepository.find({
                            relations:['village'],
                            where:{status:1,isPinned:true},
                            order: {pinDate: "DESC"},
                            skip:pageDto.skip,
                            take: 10
                        });
                    }
                }
                if(pageDto.type == 1) {
                  if(pageDto.categoryId > 0) {
                    var posts = await this.postRepository.find({
                        where:{status:1,isPinned:false,postCategoryId:pageDto.categoryId},
                        order: {createdAt: "DESC"},
                        skip:pageDto.skip,
                        take: 10
                    });  
                   } else {
                        var posts = await this.postRepository.find({
                        where:{status:1,isPinned:false},
                        order: {createdAt: "DESC"},
                        skip:pageDto.skip,
                        take: 10
                    	});  
                    }                     
                }                    
                if(pageDto.type == 2) {
                    if(pageDto.categoryId > 0) {
                        var posts = await this.postRepository.find({
                            where:{status:1,isDevelopmentPost:0,postCategoryId:pageDto.categoryId},
                            order: {createdAt: "DESC"},
                            skip:pageDto.skip,
                            take: 10
                        }); 
                    } else {
                        var posts = await this.postRepository.find({
                            where:{status:1,isDevelopmentPost:0},
                            order: {createdAt: "DESC"},
                            skip:pageDto.skip,
                            take: 10
                        }); 
                    }
                }
                if(pageDto.type == 3) {
                    if(pageDto.categoryId > 0) {
                        var posts = await this.postRepository
                        .createQueryBuilder("post")
                        .innerJoinAndSelect('post.postactivity','postactivity','postactivity.postId = post.Id')
                        .where('post.status=:da', { da: true })
                        .andWhere('postactivity.fev=:f',{f:true})
                        .andWhere('postactivity.userId=:u',{u:userId})
                        .andWhere('post.postCategoryId=:ci',{ci:pageDto.categoryId})
                        .orderBy('post.createdAt','DESC')
                        .skip(pageDto.skip)
                        .take(10)
                        .getMany(); 
                   } else {
                    var posts = await this.postRepository
                        .createQueryBuilder("post")
                        .innerJoinAndSelect('post.postactivity','postactivity','postactivity.postId = post.Id')
                        .where('post.status=:da', { da: true })
                        .andWhere('postactivity.fev=:f',{f:true})
                        .andWhere('postactivity.userId=:u',{u:userId})
                        .orderBy('post.createdAt','DESC')
                        .skip(pageDto.skip)
                        .take(10)
                        .getMany(); 
                    }      
                }
                if(pageDto.type == 4) {
                    if(pageDto.villageId > 0) { 
                        if(pageDto.filterId == 0) {
                            if(pageDto.categoryId > 0) {
                                var posts = await this.postRepository.find({
                                    where:{status:1,isDevelopmentPost:1,villageId:pageDto.villageId,postCategoryId:pageDto.categoryId},
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            } else {
                                var posts = await this.postRepository.find({
                                    where:{status:1,isDevelopmentPost:1,villageId:pageDto.villageId},
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            }
                        } else if(pageDto.filterId == 1) {
                            var sname = 'new';
                            var sname2 = 'Yet to start';
                            if(pageDto.categoryId > 0) {
                                var posts = await this.postRepository.find({
                                    where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId,postCategoryId:pageDto.categoryId},
                                    {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId,postCategoryId:pageDto.categoryId}],
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            } else {
                                var posts = await this.postRepository.find({
                                    where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId},
                                    {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId}],
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
		                    }
                        } else if(pageDto.filterId == 2) {
                            var sname = 'In Progress';
                            var sname2 = 'InProgress';
                            if(pageDto.categoryId > 0) {
                                var posts = await this.postRepository.find({
                                    where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId,postCategoryId:pageDto.categoryId},
                                    {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId,postCategoryId:pageDto.categoryId}],
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
		                    } else {
                                var posts = await this.postRepository.find({
                                            where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId},
                                            {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId}],
                                            order: {createdAt: "DESC"},
                                            skip:pageDto.skip,
                                            take: 10
                                            });
		                    }
                        } else if(pageDto.filterId == 3) {
                            var sname = 'closed';
                            var sname2 = 'completed';
                            if(pageDto.categoryId > 0) {
                                var posts = await this.postRepository.find({
                                    where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId,postCategoryId:pageDto.categoryId},
                                    {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId,postCategoryId:pageDto.categoryId}],
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            }  else {
                                var posts = await this.postRepository.find({
                                        where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId},
                                        {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId}],
                                        order: {createdAt: "DESC"},
                                        skip:pageDto.skip,
                                        take: 10
                                    });
                            }          
                        
                        } 
                    } else { 
                        if(pageDto.filterId == 0) {
                            if(pageDto.categoryId > 0) {
                                var posts = await this.postRepository.find({
                                    where:{status:1,isDevelopmentPost:1,postCategoryId:pageDto.categoryId},
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            } else {
                                var posts = await this.postRepository.find({
                                    where:{status:1,isDevelopmentPost:1},
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            }
                        } else if(pageDto.filterId == 1) {
                            var sname = 'new';
                            var sname2 = 'Yet to start';
                            if(pageDto.categoryId > 0) {
                                var posts = await this.postRepository.find({
                                    where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,postCategoryId:pageDto.categoryId},
                                    {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,postCategoryId:pageDto.categoryId}],
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            } else {
                                var posts = await this.postRepository.find({
                                    where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1},
                                    {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1}],
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            }
                            
                        } else if(pageDto.filterId == 2) {
                            var sname = 'In Progress';
                            var sname2 = 'InProgress';
                            if(pageDto.categoryId > 0) {
                                var posts = await this.postRepository.find({
                                    where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,postCategoryId:pageDto.categoryId},
                                    {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,postCategoryId:pageDto.categoryId}],
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            } else {
                                var posts = await this.postRepository.find({
                                    where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1},
                                    {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1}],
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            }
                            
                        } else if(pageDto.filterId == 3) {
                            var sname = 'closed';
                            var sname2 = 'completed';
                            if(pageDto.categoryId > 0) {
                            var posts = await this.postRepository.find({
                                    where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,postCategoryId:pageDto.categoryId},
                                    {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,postCategoryId:pageDto.categoryId}],
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            } else {
                            var posts = await this.postRepository.find({
                                    where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1},
                                    {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1}],
                                    order: {createdAt: "DESC"},
                                    skip:pageDto.skip,
                                    take: 10
                                });
                            }
                            
                        }            
                        
                    }                                  
                } 
                if(pageDto.type == 5) {
                    if(pageDto.categoryId > 0) {
                        var posts = await this.postRepository.find({
                            where:{status:1, userId:userId,postCategoryId:pageDto.categoryId},
                            order: {createdAt: "DESC"},
                            skip:pageDto.skip,
                            take: 10
                        });
                    } else {
                    var posts = await this.postRepository.find({
                            where:{status:1, userId:userId},
                            order: {createdAt: "DESC"},
                            skip:pageDto.skip,
                            take: 10
                        });
                    }
                } 
                if(!posts) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const promises = posts.map(async (post) => {
                    const user = await this.profileService.getUserByUId(post.userId);
                    const ldfCount = await this.postActService.getPostLikDisLikFavCount(post.Id);
                    const cmtCount =  await this.cmntService.getPostCmtsCount(post.Id);
                    const ldfStatus = await this.postActService.getPostLikDisLikFavStatus(post.Id,userId);
                    const postImages = await this.postFilesService.getPostFiles(post.Id, 'image');
                    const postVideos = await this.postFilesService.getPostFiles(post.Id,'video');
                    const postPoll  = await this.pollService.getPostPoll(post.Id);
                    const postCategory = await this.postCategoryRepo.findOne({where:{Id:post.postCategoryId}});
                    if(postPoll.length > 0) {
                        const pollTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: post.Id })
                        .orderBy('status','ASC')
                        .getRawOne();
                        const tlCount = pollTotal.cnt;
                        const promises = postPoll.map(async (v) => {
                            const optionTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.Id })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .orderBy('status','ASC')
                            .getRawOne();
                            const statusTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.Id })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .andWhere('user_id=:ui',{ui:userId})
                            .orderBy('status','ASC')
                            .getRawOne();                        
                            return  {
                                pollId:v.Id,
                                pollValue:v.pollValue,
                                pollType:v.pollType,
                                polCnt: optionTotal.cnt,
                                usta: statusTotal.cnt > 0 ? true : false
                            }
                        })
                        const pda = await Promise.all(promises);
                        finPollData =[];
                        pda.map((f) => { 
                            finPollData.push({
                                pollId: f.pollId,
                                pollType:f.pollType,
                                pollValue:f.pollValue,
                                totalCount:tlCount,
                                pollCount:f.polCnt,
                                percentage: tlCount == 0 ? 0 : Math.round(f.polCnt / (tlCount / 100)),
                                userStatus: f.usta
                            })
                        });
                    } else {
                        finPollData =[];
                    }
                    //const loguser = await this.profileService.getUserByUId(userId);
                    return {
                        postId:post.Id,
                        isDevelopmentPost:post.isDevelopmentPost == 1? true:false,
                        text:post.text,
                        postTime:post.createdAt,
                        postTypeId:post.postTypeId,
                        postCategoryId:post.postCategoryId,
                        postCategoryName:postCategory != undefined? postCategory.postcategory : '',
                        villageId:post.villageId,
                        villageName:post.village != null? post.village.villageName:'',
                        userId:post.userId,
                        userName: user.firstName != null ? user.firstName :'',
                        profilePic:user.profilePic,
                        likesCount:ldfCount.likeCount,
                        likeStatus:ldfStatus != null ? ldfStatus.like : false,
                        disLikesCount:ldfCount.dislikeCount,
                        disLikeStatus:ldfStatus != null ? ldfStatus.dislike : false,
                        favCount:ldfCount.fevCount,
                        favStatus:ldfStatus != null ? ldfStatus.fev : false,
                        commentCount:cmtCount.cnt,
                        postImages:postImages,
                        postVideos:postVideos,
                        poll:finPollData,
                        pollExpire:post.pollExpire,
                        viewCount:post.viewCount,
                       // timeOffSet:loguser != null?loguser.user.timeZoneOffset:'00:00'
                    }   
                });   
                const da = await Promise.all(promises);
                da.map((f) => {  
                    if(f.postImages) {
                        f.postImages.map((i) => {
                            images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                        })
                    } 
                    if(f.postVideos) { 
                        f.postVideos.map((v) => {
                            videos.push(`${process.env.WORKINGURL}/${v.fileUrl}`)
                        })
                    }                    
                    var day_start = new Date(f.postTime);
                    var day_end = new Date();
                   // console.log(day_start,day_end)
                    var finalDys = this.timeDiffCalc(day_end,day_start)
                    if(f.pollExpire != null){
                        var day_start1 = new Date();
                        var day_end1 = new Date(f.pollExpire);
                        var finalDys1 = this.timeDiffCalc(day_end1,day_start1)
                    } else {
                        var finalDys1 = '';
                    }
                    
                    finData.push({
                        postId:f.postId,
                        isDevelopmentPost:f.isDevelopmentPost,
                        text:f.text,
                        postDays:finalDys,
                        postTime:f.postTime,
                        postTypeId:f.postTypeId,
                        postCategoryId:f.postCategoryId,
                        postCategoryName:f.postCategoryName,
                        villageId:f.villageId,
                        villageName:f.villageName,
                        userId:f.userId,
                        userName:f.userName,
                        profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
                        likesCount:f.likesCount != null ? `${f.likesCount}` : 0,
                        likeStatus:f.likeStatus,
                        disLikesCount:f.disLikesCount !=null ? `${f.disLikesCount}` : 0,
                        disLikeStatus:f.disLikeStatus,
                        favCount:f.favCount !=null ? `${f.favCount}` : 0,
                        favStatus:f.favStatus,
                        commentCount:f.commentCount !=null ? `${f.commentCount}` : 0,
                        postImages:images,
                        postVideos:videos,
                        poll:f.poll,
                        pollExpire:finalDys1,
                        viewCount:f.viewCount
                    }) 
                    images=[];
                    videos=[];
                }) 
                if(pageDto.type == 4) {                    
                    if(pageDto.villageId > 0) { 
                        var allDevPosts = await this.postRepository.find({
                            where:{status:1,isDevelopmentPost:1,villageId:pageDto.villageId},
                            order: {createdAt: "DESC"}
                        });
                        if(allDevPosts) {
                            var totalDevcnt = allDevPosts.length;
                        } else {
                            var totalDevcnt = 0;
                        }
                        if(totalDevcnt == 0) {
                            response.status = true;
                            response.data = finData;
                            response.percentData = {
                                allCount:totalDevcnt,
                                newCount:0,
                                newPercentage: 0,
                                inProgressCount:0,
                                inProgressPercentage:0,
                                closedCount:0,
                                closedPercentage:0
                            }
                            response.statusCode = 50000;
                            response.internalMessage = 'Data retrived successfully';
                            response.intlCode = 11108;
                        } else {
                            var sname = 'closed';
                            var sname2 = 'completed';
                            var cmptDevPosts = await this.postRepository.find({
                                where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId},
                                {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1,villageId:pageDto.villageId}],
                                order: {createdAt: "DESC"}
                            });

                            if(cmptDevPosts) {
                                var cmptDevcnt = cmptDevPosts.length;
                            } else {
                                var cmptDevcnt = 0;
                            }

                            var progressDevPosts = await this.postRepository.find({
                                where: [{developStatus:'in progress',status:1,isDevelopmentPost:1,villageId:pageDto.villageId},
                                {developStatus:'inprogress',status:1,isDevelopmentPost:1,villageId:pageDto.villageId}],
                                order: {createdAt: "DESC"}
                            });                            
                            
                            if(progressDevPosts) {
                                var prgrsDevcnt = progressDevPosts.length;
                            } else {
                                var prgrsDevcnt = 0;
                            }

                            var startDevPosts = await this.postRepository.find({
                                where: [{developStatus:'new',status:1,isDevelopmentPost:1,villageId:pageDto.villageId},
                                {developStatus:'Yet to start',status:1,isDevelopmentPost:1,villageId:pageDto.villageId}],
                                order: {createdAt: "DESC"}
                            });                      

                            if(startDevPosts) {
                                var strtDevcnt = startDevPosts.length;
                            } else {
                                var strtDevcnt = 0;
                            }

                            var strtPer = strtDevcnt == 0? 0 : Math.round((strtDevcnt/totalDevcnt)*100);
                            var inproPer = prgrsDevcnt == 0?0:Math.round((prgrsDevcnt/totalDevcnt)*100);
                            var cmptPer = cmptDevcnt == 0?0:Math.round((cmptDevcnt/totalDevcnt)*100);
                            response.status = true;
                            response.data = finData;
                            response.percentData = {
                                allCount:totalDevcnt,
                                newCount:strtDevcnt,
                                newPercentage: strtPer,
                                inProgressCount:prgrsDevcnt,
                                inProgressPercentage:inproPer,
                                closedCount:cmptDevcnt,
                                closedPercentage:cmptPer
                            }
                            response.statusCode = 50000;
                            response.internalMessage = 'Data retrived successfully';
                            response.intlCode = 11108;
                        }
                    } else { 
                        var allDevPosts = await this.postRepository.find({
                            where:{status:1,isDevelopmentPost:1},
                            order: {createdAt: "DESC"}
                        });
                        if(allDevPosts) {
                            var totalDevcnt = allDevPosts.length;
                        } else {
                            var totalDevcnt = 0;
                        }
                        if(totalDevcnt == 0) {
                            response.status = true;
                            response.data = finData;
                            response.percentData = {
                                allCount:totalDevcnt,
                                newCount:0,
                                newPercentage: 0,
                                inProgressCount:0,
                                inProgressPercentage:0,
                                closedCount:0,
                                closedPercentage:0
                            }
                            response.statusCode = 50000;
                            response.internalMessage = 'Data retrived successfully';
                            response.intlCode = 11108;
                        } else {
                            var sname = 'completed';
                            var sname2 = 'closed';
                            var cmptDevPosts = await this.postRepository.find({
                                where: [{developStatus:Raw(alias => `UPPER(develop_status) = '${sname.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1},
                                {developStatus:Raw(alias => `UPPER(develop_status) = '${sname2.toLocaleUpperCase()}'`),status:1,isDevelopmentPost:1}],
                                order: {createdAt: "DESC"}
                            });

                            if(cmptDevPosts) {
                                var cmptDevcnt = cmptDevPosts.length;
                            } else {
                                var cmptDevcnt = 0;
                            }

                            var progressDevPosts = await this.postRepository.find({
                                where: [{developStatus:'in progress',status:1,isDevelopmentPost:1},
                                {developStatus:'inprogress',status:1,isDevelopmentPost:1}],
                                order: {createdAt: "DESC"}
                            });                            
                            
                            if(progressDevPosts) {
                                var prgrsDevcnt = progressDevPosts.length;
                            } else {
                                var prgrsDevcnt = 0;
                            }

                            var startDevPosts = await this.postRepository.find({
                                where: [{developStatus:'new',status:1,isDevelopmentPost:1},
                                {developStatus:'Yet to start',status:1,isDevelopmentPost:1}],
                                order: {createdAt: "DESC"}
                            });                      

                            if(startDevPosts) {
                                var strtDevcnt = startDevPosts.length;
                            } else {
                                var strtDevcnt = 0;
                            }

                            var strtPer = strtDevcnt == 0? 0 : Math.round((strtDevcnt/totalDevcnt)*100);
                            var inproPer = prgrsDevcnt == 0?0:Math.round((prgrsDevcnt/totalDevcnt)*100);
                            var cmptPer = cmptDevcnt == 0?0:Math.round((cmptDevcnt/totalDevcnt)*100);
                            response.status = true;
                            response.data = finData;
                            response.percentData = {
                                allCount:totalDevcnt,
                                newCount:strtDevcnt,
                                newPercentage: strtPer,
                                inProgressCount:prgrsDevcnt,
                                inProgressPercentage:inproPer,
                                closedCount:cmptDevcnt,
                                closedPercentage:cmptPer
                            }
                            response.statusCode = 50000;
                            response.internalMessage = 'Data retrived successfully';
                            response.intlCode = 11108;
                        }
                    }
                } else {
                    if(finData.length > 0) { 
                        response.status = true;
                        response.data = finData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Data retrieved successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Data not found');
                    }
                } 
            }
            return response;
        } catch(error) {
           throw error;//new ErrorResponse(99998, error);
        }
    }

    async getNewPosts(pageDto:Pagination2Dto, request:Request):Promise<AllPostsResponseModel> {
        const response = new AllPostsResponseModel();
        try {
            const finData: any[] = [];
            let finPollData: any[] = []; 
            let images: any[] = [];
            let videos: any[] = [];           
            if(pageDto.apiVersion == 1) {
                if(!pageDto.skip || pageDto.skip == null) {
                    pageDto.skip = 0;
                } 
               
                var posts = await this.postRepository.find({
                    where:{status:pageDto.type},
                    order: {createdAt: "DESC"},
                    skip:pageDto.skip,
                    take: 10
                });             
                
               
                if(!posts) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const promises = posts.map(async (post) => {
                    const user = await this.profileService.getUserByUId(post.userId);
                    const postImages = await this.postFilesService.getPostFiles(post.Id, 'image');
                    const postVideos = await this.postFilesService.getPostFiles(post.Id,'video');
                    const postPoll  = await this.pollService.getPostPoll(post.Id);
                    const postCategory = await this.postCategoryRepo.findOne({where:{Id:post.postCategoryId}});
                    if(postPoll.length > 0) {
                        const pollTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: post.Id })
                        .orderBy('status','ASC')
                        .getRawOne();
                        const tlCount = pollTotal.cnt;
                        const promises = postPoll.map(async (v) => {
                            const optionTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.Id })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .orderBy('status','ASC')
                            .getRawOne();
                            const statusTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.Id })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .orderBy('status','ASC')
                            .getRawOne();                        
                            return  {
                                pollId:v.Id,
                                pollValue:v.pollValue,
                                pollType:v.pollType,
                                polCnt: optionTotal.cnt,
                                usta: statusTotal.cnt > 0 ? true : false
                            }
                        })
                        const pda = await Promise.all(promises);
                        finPollData =[];
                        pda.map((f) => { 
                            finPollData.push({
                                pollId: f.pollId,
                                pollType:f.pollType,
                                pollValue:f.pollValue,
                                totalCount:tlCount,
                                pollCount:f.polCnt,
                                percentage: tlCount == 0 ? 0 : Math.round(f.polCnt / (tlCount / 100)),
                                userStatus: f.usta
                            })
                        });
                    } else {
                        finPollData =[];
                    }
                    //const loguser = await this.profileService.getUserByUId(userId);
                    return {
                        postId:post.Id,
                        isDevelopmentPost:post.isDevelopmentPost == 1? true:false,
                        text:post.text,
                        postTime:post.createdAt,
                        postTypeId:post.postTypeId,
                        postCategoryId:post.postCategoryId,
                        postCategoryName:postCategory != undefined ? postCategory.postcategory :'',
                        villageId:post.villageId,
                        villageName:post.village != null? post.village.villageName:'',
                        userId:post.userId,
                        userName: user.firstName != null ? user.firstName :'',
                        profilePic:user.profilePic,
                        postImages:postImages,
                        postVideos:postVideos,
                        poll:finPollData,
                        pollExpire:post.pollExpire,
                        viewCount:post.viewCount,
                       // timeOffSet:loguser != null?loguser.user.timeZoneOffset:'00:00'
                    }   
                });   
                const da = await Promise.all(promises);
                da.map((f) => {  
                    if(f.postImages) {
                        f.postImages.map((i) => {
                            images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                        })
                    } 
                    if(f.postVideos) { 
                        f.postVideos.map((v) => {
                            videos.push(`${process.env.WORKINGURL}/${v.fileUrl}`)
                        })
                    }                    
                    var day_start = new Date(f.postTime);
                    var day_end = new Date();
                   // console.log(day_start,day_end)
                    var finalDys = this.timeDiffCalc(day_end,day_start)
                    if(f.pollExpire != null){
                        var day_start1 = new Date();
                        var day_end1 = new Date(f.pollExpire);
                        var finalDys1 = this.timeDiffCalc(day_end1,day_start1)
                    } else {
                        var finalDys1 = '';
                    }
                    
                    finData.push({
                        postId:f.postId,
                        isDevelopmentPost:f.isDevelopmentPost,
                        text:f.text,
                        postDays:finalDys,
                        postTime:f.postTime,
                        postTypeId:f.postTypeId,
                        postCategoryId:f.postCategoryId,
                        postCategoryName:f.postCategoryName,
                        villageId:f.villageId,
                        villageName:f.villageName,
                        userId:f.userId,
                        userName:f.userName,
                        profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
                       postImages:images,
                        postVideos:videos,
                        poll:f.poll,
                        pollExpire:finalDys1,
                        viewCount:f.viewCount
                    }) 
                    images=[];
                    videos=[];
                }) 
                 if(finData.length > 0) { 
                        response.status = true;
                        response.data = finData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Data retrieved successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Data not found');
                    }
            } else  {
                if(!pageDto.skip || pageDto.skip == null) {
                    pageDto.skip = 0;
                } 
               
                var posts = await this.postRepository.find({
                    where:{status:pageDto.type},
                    order: {createdAt: "DESC"},
                    skip:pageDto.skip,
                    take: 10
                });             
                
               
                if(!posts) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const promises = posts.map(async (post) => {
                    const user = await this.profileService.getUserByUId(post.userId);
                    const postImages = await this.postFilesService.getPostFiles(post.Id, 'image');
                    const postVideos = await this.postFilesService.getPostFiles(post.Id,'video');
                    const postPoll  = await this.pollService.getPostPoll(post.Id);
                    const postCategory = await this.postCategoryRepo.findOne({where:{Id:post.postCategoryId}});
                    if(postPoll.length > 0) {
                        const pollTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: post.Id })
                        .orderBy('status','ASC')
                        .getRawOne();
                        const tlCount = pollTotal.cnt;
                        const promises = postPoll.map(async (v) => {
                            const optionTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.Id })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .orderBy('status','ASC')
                            .getRawOne();
                            const statusTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.Id })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .orderBy('status','ASC')
                            .getRawOne();                        
                            return  {
                                pollId:v.Id,
                                pollValue:v.pollValue,
                                pollType:v.pollType,
                                polCnt: optionTotal.cnt,
                                usta: statusTotal.cnt > 0 ? true : false
                            }
                        })
                        const pda = await Promise.all(promises);
                        finPollData =[];
                        pda.map((f) => { 
                            finPollData.push({
                                pollId: f.pollId,
                                pollType:f.pollType,
                                pollValue:f.pollValue,
                                totalCount:tlCount,
                                pollCount:f.polCnt,
                                percentage: tlCount == 0 ? 0 : Math.round(f.polCnt / (tlCount / 100)),
                                userStatus: f.usta
                            })
                        });
                    } else {
                        finPollData =[];
                    }
                    //const loguser = await this.profileService.getUserByUId(userId);
                    return {
                        postId:post.Id,
                        isDevelopmentPost:post.isDevelopmentPost == 1? true:false,
                        text:post.text,
                        postTime:post.createdAt,
                        postTypeId:post.postTypeId,
                        postCategoryId:post.postCategoryId,
                        postCategoryName:postCategory != undefined ? postCategory.postcategory :'',
                        villageId:post.villageId,
                        villageName:post.village != null? post.village.villageName:'',
                        userId:post.userId,
                        userName: user.firstName != null ? user.firstName :'',
                        profilePic:user.profilePic,
                        postImages:postImages,
                        postVideos:postVideos,
                        poll:finPollData,
                        pollExpire:post.pollExpire,
                        viewCount:post.viewCount,
                       // timeOffSet:loguser != null?loguser.user.timeZoneOffset:'00:00'
                    }   
                });   
                const da = await Promise.all(promises);
                da.map((f) => {  
                    if(f.postImages) {
                        f.postImages.map((i) => {
                            images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                        })
                    } 
                    if(f.postVideos) { 
                        f.postVideos.map((v) => {
                            videos.push(`${process.env.WORKINGURL}/${v.fileUrl}`)
                        })
                    }                    
                    var day_start = new Date(f.postTime);
                    var day_end = new Date();
                   // console.log(day_start,day_end)
                    var finalDys = this.timeDiffCalc(day_end,day_start)
                    if(f.pollExpire != null){
                        var day_start1 = new Date();
                        var day_end1 = new Date(f.pollExpire);
                        var finalDys1 = this.timeDiffCalc(day_end1,day_start1)
                    } else {
                        var finalDys1 = '';
                    }
                    
                    finData.push({
                        postId:f.postId,
                        isDevelopmentPost:f.isDevelopmentPost,
                        text:f.text,
                        postDays:finalDys,
                        postTime:f.postTime,
                        postTypeId:f.postTypeId,
                        postCategoryId:f.postCategoryId,
                        postCategoryName:f.postCategoryName,
                        villageId:f.villageId,
                        villageName:f.villageName,
                        userId:f.userId,
                        userName:f.userName,
                        profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
                       postImages:images,
                        postVideos:videos,
                        poll:f.poll,
                        pollExpire:finalDys1,
                        viewCount:f.viewCount
                    }) 
                    images=[];
                    videos=[];
                }) 
                 if(finData.length > 0) { 
                        response.status = true;
                        response.data = finData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Data retrieved successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Data not found');
                    }
            } 
            return response;
        } catch(error) {
           throw error;//new ErrorResponse(99998, error);
        }
    }

    async getPostById(queryParams, postId,userId,request:Request):Promise<SingleResponseModel> {
        const response = new SingleResponseModel();
        try {
            let images: any[] = [];
            let videos: any[] = [];
            let finPollData: any[] =[];
            if (queryParams.apiVersion == 1) {
                var post = await this.postRepository.findOne({
                    relations:['village'],
                    where:{Id:postId}
                });                     
                if(!post) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const user = await this.profileService.getUserByUId(post.userId);
                const ldfCount = await this.postActService.getPostLikDisLikFavCount(post.Id);
                const cmtCount =  await this.cmntService.getPostCmtsCount(post.Id);
                const ldfStatus = await this.postActService.getPostLikDisLikFavStatus(post.Id,userId);
                const postImages = await this.postFilesService.getPostFiles(post.Id, 'image');
                const postVideos = await this.postFilesService.getPostFiles(post.Id,'video');
                const postPoll  = await this.pollService.getPostPoll(post.Id);
                const postCategory = await this.postCategoryRepo.findOne({where:{Id:post.postCategoryId}});
                if(postPoll.length > 0) {
                    const pollTotal = await getConnection()
                    .createQueryBuilder()
                    .select("count(*) as cnt")
                    .from(PollVotingEntity, "PollVoting")
                    .where('post_id=:da', { da: post.Id })
                    .orderBy('status','ASC')
                    .getRawOne();
                    const tlCount = pollTotal.cnt;
                    const promises = postPoll.map(async (v) => {
                        const optionTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: post.Id })
                        .andWhere('poll_id=:pi',{pi:v.Id})
                        .orderBy('status','ASC')
                        .getRawOne();
                        const statusTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: post.Id })
                        .andWhere('poll_id=:pi',{pi:v.Id})
                        .andWhere('user_id=:ui',{ui:userId})
                        .orderBy('status','ASC')
                        .getRawOne();                        
                        return  {
                            pollId:v.Id,
                            pollValue:v.pollValue,
                            pollType:v.pollType,
                            polCnt: optionTotal.cnt,
                            usta: statusTotal.cnt > 0 ? true : false
                        }
                    })
                    const da = await Promise.all(promises);
                    da.map((f) => { 
                        finPollData.push({
                            pollId: f.pollId,
                            pollType:f.pollType,
                            pollValue:f.pollValue,
                            totalCount:tlCount,
                            pollCount:f.polCnt,
                            percentage: tlCount == 0 ? 0 : Math.round(f.polCnt / (tlCount / 100)),
                            userStatus: f.usta
                        })
                    });
                } else {
                    finPollData = [];
                }
                if(postImages) {
                    postImages.map((i) => {
                        images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                    })
                } 
                if(postVideos) { 
                    postVideos.map((v) => {
                        videos.push(`${process.env.WORKINGURL}/${v.fileUrl}`)
                    })
                }
                var day_start = new Date(post.createdAt);
                var day_end = new Date();
                var finalDys = this.timeDiffCalc(day_end,day_start)
                if(post.pollExpire != null){
                    var day_start1 = new Date();
                    var day_end1 = new Date(post.pollExpire);
                    var finalDys1 = this.timeDiffCalc(day_end1,day_start1)
                } else {
                    var finalDys1 = '';
                }
                let final = {
                    postId:post.Id,
                    isDevelopmentPost:post.isDevelopmentPost == 1?true:false,
                    text:post.text,
                    postDays:finalDys,
                    postTime:post.createdAt,
                    postTypeId:post.postTypeId,
                    postCategoryId:post.postCategoryId,
                    postCategoryName:postCategory != undefined ? postCategory.postcategory : '',
                    villageId:post.villageId,
                    villageName:post.village != null? post.village.villageName:'',
                    userId:post.userId,
                    userName: user.firstName != null ? user.firstName :'',
                    profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
                    likesCount:ldfCount.likesCount != null ? `${ldfCount.likesCount}` : 0,
                    likeStatus:ldfStatus != null ? ldfStatus.like : false,
                    disLikesCount:ldfCount.disLikesCount !=null ? `${ldfCount.disLikesCount}` : 0,
                    disLikeStatus:ldfStatus != null ? ldfStatus.dislike : false,
                    favCount:ldfCount.favCount != null ? `${ldfCount.favCount}` : 0,
                    favStatus:ldfStatus != null ? ldfStatus.fev : false,
                    commentCount:cmtCount.cnt != null ? cmtCount.cnt : 0,
                    postImages:images,
                    postVideos:videos,
                    poll:finPollData,
                    pollExpire:finalDys1,
                    viewCount:post.viewCount
                }
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;
            } else {
                var post = await this.postRepository.findOne({
                    relations:['village'],
                    where:{Id:postId}
                });                     
                if(!post) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const user = await this.profileService.getUserByUId(post.userId);
                const ldfCount = await this.postActService.getPostLikDisLikFavCount(post.Id);
                const cmtCount =  await this.cmntService.getPostCmtsCount(post.Id);
                const ldfStatus = await this.postActService.getPostLikDisLikFavStatus(post.Id,userId);
                const postImages = await this.postFilesService.getPostFiles(post.Id, 'image');
                const postVideos = await this.postFilesService.getPostFiles(post.Id,'video');
                const postPoll  = await this.pollService.getPostPoll(post.Id);
                const postCategory = await this.postCategoryRepo.findOne({where:{Id:post.postCategoryId}});
                if(postPoll.length > 0) {
                    const pollTotal = await getConnection()
                    .createQueryBuilder()
                    .select("count(*) as cnt")
                    .from(PollVotingEntity, "PollVoting")
                    .where('post_id=:da', { da: post.Id })
                    .orderBy('status','ASC')
                    .getRawOne();
                    const tlCount = pollTotal.cnt;
                    const promises = postPoll.map(async (v) => {
                        const optionTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: post.Id })
                        .andWhere('poll_id=:pi',{pi:v.Id})
                        .orderBy('status','ASC')
                        .getRawOne();
                        const statusTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: post.Id })
                        .andWhere('poll_id=:pi',{pi:v.Id})
                        .andWhere('user_id=:ui',{ui:userId})
                        .orderBy('status','ASC')
                        .getRawOne();                        
                        return  {
                            pollId:v.Id,
                            pollValue:v.pollValue,
                            pollType:v.pollType,
                            polCnt: optionTotal.cnt,
                            usta: statusTotal.cnt > 0 ? true : false
                        }
                    })
                    const da = await Promise.all(promises);
                    da.map((f) => { 
                        finPollData.push({
                            pollId: f.pollId,
                            pollType:f.pollType,
                            pollValue:f.pollValue,
                            totalCount:tlCount,
                            pollCount:f.polCnt,
                            percentage: tlCount == 0 ? 0 : Math.round(f.polCnt / (tlCount / 100)),
                            userStatus: f.usta
                        })
                    });
                } else {
                    finPollData = [];
                }
                if(postImages) {
                    postImages.map((i) => {
                        images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                    })
                } 
                if(postVideos) { 
                    postVideos.map((v) => {
                        videos.push(`${process.env.WORKINGURL}/${v.fileUrl}`)
                    })
                }
                var day_start = new Date(post.createdAt);
                var day_end = new Date();
                var finalDys = this.timeDiffCalc(day_end,day_start)
                if(post.pollExpire != null){
                    var day_start1 = new Date();
                    var day_end1 = new Date(post.pollExpire);
                    var finalDys1 = this.timeDiffCalc(day_end1,day_start1)
                } else {
                    var finalDys1 = '';
                }
                let final = {
                    postId:post.Id,
                    isDevelopmentPost:post.isDevelopmentPost == 1?true:false,
                    text:post.text,
                    postDays:finalDys,
                    postTime:post.createdAt,
                    postTypeId:post.postTypeId,
                    postCategoryId:post.postCategoryId,
                    postCategoryName:postCategory != undefined ? postCategory.postcategory : '',
                    villageId:post.villageId,
                    villageName:post.village != null? post.village.villageName:'',
                    userId:post.userId,
                    userName: user.firstName != null ? user.firstName :'',
                    profilePic: user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : '',
                    likesCount:ldfCount.likesCount != null ? `${ldfCount.likesCount}` : 0,
                    likeStatus:ldfStatus != null ? ldfStatus.like : false,
                    disLikesCount:ldfCount.disLikesCount !=null ? `${ldfCount.disLikesCount}` : 0,
                    disLikeStatus:ldfStatus != null ? ldfStatus.dislike : false,
                    favCount:ldfCount.favCount != null ? `${ldfCount.favCount}` : 0,
                    favStatus:ldfStatus != null ? ldfStatus.fev : false,
                    commentCount:cmtCount.cnt != null ? cmtCount.cnt : 0,
                    postImages:images,
                    postVideos:videos,
                    poll:finPollData,
                    pollExpire:finalDys1,
                    viewCount:post.viewCount
                }
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async getLatestRefreshedPosts(pageDto:Pagination1Dto, userId,request:Request):Promise<AllPostsResponseModel> {
        const response = new AllPostsResponseModel();
        try {
            const finData: any[] = [];
            let finPollData: any[] = [];
            let images: any[] = [];
            let videos: any[] = [];
            let userAry: any[] = [];
            var useRole = await this.useRepo.findOne({
                where:{Id:userId}
            })
            userAry.push(userId)                        
            if(useRole.roleId == 3 || useRole.roleId == 4 || useRole.roleId == 5) {
                var users = await this.hierarchyRepo.findOne({
                    where:{masterLoginId:userId}
                }) 
                if(users) {
                    userAry.push(users.nextLevelLoginId);
                    var nextUser = await this.hierarchyRepo.findOne({
                        where:{masterLoginId:users.nextLevelLoginId}
                    })
                    if(nextUser) {
                        userAry.push(nextUser.nextLevelLoginId);
                        var next2User = await this.hierarchyRepo.findOne({
                            where:{masterLoginId:nextUser.nextLevelLoginId}
                        })
                        if(next2User) {
                            userAry.push(next2User.nextLevelLoginId);
                        }
                    }
                }
            }
            if(pageDto.apiVersion == 1) {
                /* if(useRole.roleId == 3 || useRole.roleId == 4 || useRole.roleId == 5) {
                    var posts = await this.postRepository.find({
                        where:{status:1,isDevelopmentPost:0,isPinned:false,Id:MoreThan(pageDto.lastPostId),userId:In(userAry)},
                        order: {createdAt: "DESC"},
                        skip:pageDto.skip,
                        take: 10
                    });                    
                } else {
                    var posts = await this.postRepository.find({
                        where:{status:1,isDevelopmentPost:0,isPinned:false,Id:MoreThan(pageDto.lastPostId)},
                        order: {createdAt: "DESC"},
                        skip:pageDto.skip,
                        take: 10
                    });                        
                } */
                const posts = await this.postRepository.find({
                    where:{status:1,isDevelopmentPost:0,isPinned:false,Id:MoreThan(pageDto.lastPostId)},
                    order: {createdAt: "DESC"},
                    skip:pageDto.skip,
                    take: 10
                });                        
                if(!posts) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const promises = posts.map(async (post) => {
                    const user = await this.profileService.getUserByUId(post.userId);
                    const ldfCount = await this.postActService.getPostLikDisLikFavCount(post.Id);
                    const cmtCount =  await this.cmntService.getPostCmtsCount(post.Id);
                    const ldfStatus = await this.postActService.getPostLikDisLikFavStatus(post.Id,userId);
                    const postImages = await this.postFilesService.getPostFiles(post.Id, 'image');
                    const postVideos = await this.postFilesService.getPostFiles(post.Id,'video');
                    const postPoll  = await this.pollService.getPostPoll(post.Id);
                    const postCategory = await this.postCategoryRepo.findOne({where:{Id:post.postCategoryId}});
                    if(postPoll.length > 0) {
                        const pollTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: post.Id })
                        .orderBy('status','ASC')
                        .getRawOne();
                        const tlCount = pollTotal.cnt;
                        const promises = postPoll.map(async (v) => {
                            const optionTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.Id })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .orderBy('status','ASC')
                            .getRawOne();
                            const statusTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.Id })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .andWhere('user_id=:ui',{ui:userId})
                            .orderBy('status','ASC')
                            .getRawOne();                        
                            return  {
                                pollId:v.Id,
                                pollValue:v.pollValue,
                                pollType:v.pollType,
                                polCnt: optionTotal.cnt,
                                usta: statusTotal.cnt > 0 ? true : false
                            }
                        })
                        const pda = await Promise.all(promises);
                        finPollData =[];
                        pda.map((f) => { 
                            finPollData.push({
                                pollId: f.pollId,
                                pollType:f.pollType,
                                pollValue:f.pollValue,
                                totalCount:tlCount,
                                pollCount:f.polCnt,
                                percentage: tlCount == 0 ? 0 : Math.round(f.polCnt / (tlCount / 100)),
                                userStatus: f.usta
                            })
                        });
                    } else {
                        finPollData =[];
                    }
                    return {
                        postId:post.Id,
                        isDevelopmentPost:post.isDevelopmentPost == 1 ? true:false,
                        text:post.text,
                        postTime:post.createdAt,
                        postTypeId:post.postTypeId,
                        postCategoryId:post.postCategoryId,
                        postCategoryName: postCategory != undefined ? postCategory.postcategory : '',
                        villageId:post.villageId,
                        villageName:post.village != null?post.village.villageName:'',
                        userId:post.userId,
                        userName: user.firstName != null ? user.firstName :'',
                        profilePic:user.profilePic,
                        likesCount:ldfCount.likeCount,
                        likeStatus:ldfStatus != null ? ldfStatus.like : false,
                        disLikesCount:ldfCount.dislikeCount,
                        disLikeStatus:ldfStatus != null ? ldfStatus.dislike : false,
                        favCount:ldfCount.fevCount,
                        favStatus:ldfStatus != null ? ldfStatus.fev : false,
                        commentCount:cmtCount.cnt,
                        postImages:postImages,
                        postVideos:postVideos,
                        poll:finPollData,
                        pollExpire:post.pollExpire,
                        viewCount:post.viewCount
                    }   
                });   
                const da = await Promise.all(promises);
                da.map((f) => {  
                    if(f.postImages) {
                        f.postImages.map((i) => {
                            images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                        })
                    } 
                    if(f.postVideos) { 
                        f.postVideos.map((v) => {
                            videos.push(`${process.env.WORKINGURL}/${v.fileUrl}`)
                        })
                    }
                    var day_start = new Date(f.postTime);
                    var day_end = new Date();
                    var finalDys = this.timeDiffCalc(day_end,day_start)
                    if(f.pollExpire != null){
                        var day_start1 = new Date();
                        var day_end1 = new Date(f.pollExpire);
                        var finalDys1 = this.timeDiffCalc(day_end1,day_start1)
                    } else {
                        var finalDys1 = '';
                    }
                    finData.push({
                        postId:f.postId,
                        isDevelopmentPost:f.isDevelopmentPost,
                        text:f.text,
                        postDays:finalDys,
                        postTime:f.postTime,
                        postTypeId:f.postTypeId,
                        postCategoryId: f.postCategoryId,
                        postcategoryName:f.postCategoryName,
                        villageId:f.villageId,
                        villageName:f.villageName,
                        userId:f.userId,
                        userName:f.userName,
                        profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
                        likesCount:f.likesCount != null ? `${f.likesCount}` : 0,
                        likeStatus:f.likeStatus,
                        disLikesCount:f.disLikesCount !=null ? `${f.disLikesCount}` : 0,
                        disLikeStatus:f.disLikeStatus,
                        favCount:f.favCount !=null ? `${f.favCount}` : 0,
                        favStatus:f.favStatus,
                        commentCount:f.commentCount !=null ? `${f.commentCount}` : 0,
                        postImages:images,
                        postVideos:videos,
                        poll:f.poll,
                        pollExpire: finalDys1 ,
                        viewCount:f.viewCount
                    }) 
                    images=[];
                    videos=[];
                }) 
                if(finData.length > 0) { 
                    response.status = true;
                    response.data = finData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                } 
            } else {
                /* if(useRole.roleId == 3 || useRole.roleId == 4 || useRole.roleId == 5) {
                    var posts = await this.postRepository.find({
                        where:{status:1,isDevelopmentPost:0,isPinned:false,Id:MoreThan(pageDto.lastPostId),userId:In(userAry)},
                        order: {createdAt: "DESC"},
                        skip:pageDto.skip,
                        take: 10
                    });                    
                } else {
                    var posts = await this.postRepository.find({
                        where:{status:1,isDevelopmentPost:0,isPinned:false,Id:MoreThan(pageDto.lastPostId)},
                        order: {createdAt: "DESC"},
                        skip:pageDto.skip,
                        take: 10
                    });                        
                } */
                const posts = await this.postRepository.find({
                    where:{status:1,isDevelopmentPost:0,isPinned:false,Id:MoreThan(pageDto.lastPostId)},
                    order: {createdAt: "DESC"},
                    skip:pageDto.skip,
                    take: 10
                });                        
                if(!posts) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const promises = posts.map(async (post) => {
                    const user = await this.profileService.getUserByUId(post.userId);
                    const ldfCount = await this.postActService.getPostLikDisLikFavCount(post.Id);
                    const cmtCount =  await this.cmntService.getPostCmtsCount(post.Id);
                    const ldfStatus = await this.postActService.getPostLikDisLikFavStatus(post.Id,userId);
                    const postImages = await this.postFilesService.getPostFiles(post.Id, 'image');
                    const postVideos = await this.postFilesService.getPostFiles(post.Id,'video');
                    const postPoll  = await this.pollService.getPostPoll(post.Id);
                    const postCategory = await this.postCategoryRepo.findOne({where:{Id:post.postCategoryId}});
                    if(postPoll.length > 0) {
                        const pollTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: post.Id })
                        .orderBy('status','ASC')
                        .getRawOne();
                        const tlCount = pollTotal.cnt;
                        const promises = postPoll.map(async (v) => {
                            const optionTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.Id })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .orderBy('status','ASC')
                            .getRawOne();
                            const statusTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.Id })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .andWhere('user_id=:ui',{ui:userId})
                            .orderBy('status','ASC')
                            .getRawOne();                        
                            return  {
                                pollId:v.Id,
                                pollValue:v.pollValue,
                                pollType:v.pollType,
                                polCnt: optionTotal.cnt,
                                usta: statusTotal.cnt > 0 ? true : false
                            }
                        })
                        const pda = await Promise.all(promises);
                        finPollData =[];
                        pda.map((f) => { 
                            finPollData.push({
                                pollId: f.pollId,
                                pollType:f.pollType,
                                pollValue:f.pollValue,
                                totalCount:tlCount,
                                pollCount:f.polCnt,
                                percentage: tlCount == 0 ? 0 : Math.round(f.polCnt / (tlCount / 100)),
                                userStatus: f.usta
                            })
                        });
                    } else {
                        finPollData =[];
                    }
                    return {
                        postId:post.Id,
                        isDevelopmentPost:post.isDevelopmentPost == 1 ? true:false,
                        text:post.text,
                        postTime:post.createdAt,
                        postTypeId:post.postTypeId,
                        postCategoryId:post.postCategoryId,
                        postCategoryName: postCategory != undefined ? postCategory.postcategory : '',
                        villageId:post.villageId,
                        villageName:post.village != null?post.village.villageName:'',
                        userId:post.userId,
                        userName: user.firstName != null ? user.firstName :'',
                        profilePic:user.profilePic,
                        likesCount:ldfCount.likeCount,
                        likeStatus:ldfStatus != null ? ldfStatus.like : false,
                        disLikesCount:ldfCount.dislikeCount,
                        disLikeStatus:ldfStatus != null ? ldfStatus.dislike : false,
                        favCount:ldfCount.fevCount,
                        favStatus:ldfStatus != null ? ldfStatus.fev : false,
                        commentCount:cmtCount.cnt,
                        postImages:postImages,
                        postVideos:postVideos,
                        poll:finPollData,
                        pollExpire:post.pollExpire,
                        viewCount:post.viewCount
                    }   
                });   
                const da = await Promise.all(promises);
                da.map((f) => {  
                    if(f.postImages) {
                        f.postImages.map((i) => {
                            images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                        })
                    } 
                    if(f.postVideos) { 
                        f.postVideos.map((v) => {
                            videos.push(`${process.env.WORKINGURL}/${v.fileUrl}`)
                        })
                    }
                    var day_start = new Date(f.postTime);
                    var day_end = new Date();
                    var finalDys = this.timeDiffCalc(day_end,day_start)
                    if(f.pollExpire != null){
                        var day_start1 = new Date();
                        var day_end1 = new Date(f.pollExpire);
                        var finalDys1 = this.timeDiffCalc(day_end1,day_start1)
                    } else {
                        var finalDys1 = '';
                    }
                    finData.push({
                        postId:f.postId,
                        isDevelopmentPost:f.isDevelopmentPost,
                        text:f.text,
                        postDays:finalDys,
                        postTime:f.postTime,
                        postTypeId:f.postTypeId,
                        postCategoryId: f.postCategoryId,
                        postcategoryName:f.postCategoryName,
                        villageId:f.villageId,
                        villageName:f.villageName,
                        userId:f.userId,
                        userName:f.userName,
                        profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
                        likesCount:f.likesCount != null ? `${f.likesCount}` : 0,
                        likeStatus:f.likeStatus,
                        disLikesCount:f.disLikesCount !=null ? `${f.disLikesCount}` : 0,
                        disLikeStatus:f.disLikeStatus,
                        favCount:f.favCount !=null ? `${f.favCount}` : 0,
                        favStatus:f.favStatus,
                        commentCount:f.commentCount !=null ? `${f.commentCount}` : 0,
                        postImages:images,
                        postVideos:videos,
                        poll:f.poll,
                        pollExpire: finalDys1 ,
                        viewCount:f.viewCount
                    }) 
                    images=[];
                    videos=[];
                }) 
                if(finData.length > 0) { 
                    response.status = true;
                    response.data = finData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                } 
            }
            return response;
        } catch(error) {
           throw error;//new ErrorResponse(99998, error);
        }
    }

    async createPostPoints(pointsData) {
        try {
            const saved = await this.postPointsRepo.save(pointsData);
            if(saved) {
                const checkData = await this.userPointsRepo.findOne({
                    where:{userId:pointsData.userId}
                })
                if(checkData) {
                    pointsData.points += checkData.points;
                    await this.userPointsRepo.update(checkData.Id, {points:pointsData.points})
                } else {
                    await this.userPointsRepo.save({userId:pointsData.userId,points:pointsData.points})
                }
                return saved
            } else {
                return null;
            }
        } catch(error) {
            throw error;
        }        
    }

    async leaderBoard(queryParams,request:Request):Promise<PointsResponseModel> {
        
        const response = new PointsResponseModel();
        const finalData: any[] = [];
        try {
            if(queryParams.apiVersion == 1) {
                const allUser = await getConnection()
                .createQueryBuilder()
                .select("User.Id,userpoints.points")
                .from(UserEntity, "User")
                .leftJoinAndSelect('User.userpoints','userpoints')
                .where('User.status=:da', { da: true})
                .orderBy('userpoints.points','DESC')
                .limit(20)
                .getRawMany();
                /* const data = await this.userPointsRepo.find({
                    order: {points: "DESC"},
                }) */
                if(!allUser) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const promises = allUser.map(async (post) => {
                    const user = await this.profileService.getUserByUId(post.id);
                    const Count = await getConnection()
                    .createQueryBuilder()
                    .select("Sum(IF(points = 1, 1, 0)) as likeCount,Sum(IF(points = 2, 2, 0)) as cmntCount,Sum(IF(points = 3, 3, 0)) as shareCount,Sum(IF(points = 4, 4, 0)) as imgCount,Sum(IF(points = 5, 5, 0)) as videoCount,Sum(IF(points = 7, 7, 0)) as pollCount, count(*) as cnt")
                    .from(PostPointsEntity, "PostPoints")
                    .where('user_id=:da', { da: post.id})
                    .groupBy('user_id')
                    .orderBy('created_at','ASC')
                    .getRawOne();
                    if(user != null) {
                        var fName = user.firstName != null ? user.firstName :''
                    } else {
                        var fName = ''
                    }
                    if(user != null) {
                        var upic = user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : ''
                    } else {
                        var upic = ''
                    }
                    return {
                        userId:post.id,
                        userName: fName,
                        profilePic:upic,
                        points:post.points != null?post.points:0,
                        likeCount:Count != undefined ? Count.likeCount : 0,
                        cmntCount:Count != undefined?Count.cmntCount:0,
                        shareCount:Count !=undefined?Count.shareCount:0,
                        imgCount:Count!=undefined?Count.imgCount:0,
                        videoCount:Count!=undefined?Count.videoCount:0,
                        pollCount:Count!=undefined?Count.pollCount:0,
                        total:Count!=undefined?Count.cnt:0
                    }   
                });   
                const da = await Promise.all(promises);
                da.map((f) => { 
                    if(f.points > 0) {
                        finalData.push({
                            userId:f.userId,
                            userName: f.userName,
                            profilePic:f.profilePic ,
                            points:f.points,
                            likeCount:f.likeCount,
                            cmntCount:f.cmntCount,
                            shareCount:f.shareCount,
                            imgCount:f.imgCount,
                            videoCount:f.videoCount,
                            pollCount:f.pollCount,
                            total:f.total                        
                        })
                    } 
                }) 
                response.status = true;
                response.data = finalData;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;
            }  else {
                const allUser = await getConnection()
                .createQueryBuilder()
                .select("User.Id,userpoints.points")
                .from(UserEntity, "User")
                .leftJoinAndSelect('User.userpoints','userpoints')
                .where('User.status=:da', { da: true})
                .orderBy('userpoints.points','DESC')
                .getRawMany();
                /* const data = await this.userPointsRepo.find({
                    order: {points: "DESC"},
                }) */
                if(!allUser) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const promises = allUser.map(async (post) => {
                    const user = await this.profileService.getUserByUId(post.id);
                    const Count = await getConnection()
                    .createQueryBuilder()
                    .select("Sum(IF(points = 1, 1, 0)) as likeCount,Sum(IF(points = 2, 2, 0)) as cmntCount,Sum(IF(points = 3, 3, 0)) as shareCount,Sum(IF(points = 4, 4, 0)) as imgCount,Sum(IF(points = 5, 5, 0)) as videoCount,Sum(IF(points = 7, 7, 0)) as pollCount, count(*) as cnt")
                    .from(PostPointsEntity, "PostPoints")
                    .where('user_id=:da', { da: post.id})
                    .groupBy('user_id')
                    .orderBy('created_at','ASC')
                    .getRawOne();
                    if(user != undefined) {
                        var fName = user.firstName != null ? user.firstName :''
                    } else {
                        var fName = ''
                    }
                    if(user != undefined) {
                        var upic = user.profilePic != null ? `${process.env.WORKINGURL}/${user.profilePic}` : ''
                    } else {
                        var upic = ''
                    }
                    return {
                        userId:post.id,
                        userName: fName,
                        profilePic:upic,
                        points:post.points != null?post.points:0,
                        likeCount:Count != undefined ? Count.likeCount : 0,
                        cmntCount:Count != undefined?Count.cmntCount:0,
                        shareCount:Count !=undefined?Count.shareCount:0,
                        imgCount:Count!=undefined?Count.imgCount:0,
                        videoCount:Count!=undefined?Count.videoCount:0,
                        pollCount:Count!=undefined?Count.pollCount:0,
                        total:Count!=undefined?Count.cnt:0
                    }   
                });   
                const da = await Promise.all(promises);
                da.map((f) => {                                            
                    finalData.push({
                        userId:f.userId,
                        userName: f.userName,
                        profilePic:f.profilePic,
                        points:f.points,
                        likeCount:f.likeCount,
                        cmntCount:f.cmntCount,
                        shareCount:f.shareCount,
                        imgCount:f.imgCount,
                        videoCount:f.videoCount,
                        pollCount:f.pollCount,
                        total:f.total                        
                    }) 
                }) 
                response.status = true;
                response.data = finalData;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;
            }
            return response;
        } catch(error) {
            throw error;
        }        
    } 

    async globalSearch(queryParams,gSearchDto:GSearchDto,request:Request):Promise<SingleResponseModel> {
        const response = new SingleResponseModel();
        try {
            const finData: any[] = [];
            if(queryParams.apiVersion == 1) {
                const data = await this.postRepository.find({               
                    where: {text: Like(`%${gSearchDto.searchTerm}%`),status: true},
                    order: { createdAt: 'DESC' }
                });
                if(data) {
                    const promises = data.map(async (post) => {
                    const user = await this.profileService.getUserByUId(post.userId);
                    return {
                        postId:post.Id,
                        isDevelopmentPost:post.isDevelopmentPost == 1?true:false,
                        text:post.text,
                        postTime:post.createdAt,
                        postTypeId:post.postTypeId,
                        postCategoryId:post.postCategoryId,
                        userId:post.userId,
                        userName: user.firstName != null ? user.firstName :'',
                        profilePic:user.profilePic,
                        viewCount:post.viewCount
                    }   
                    });   
                    const da = await Promise.all(promises);
                    da.map((f) => {  
                        var day_start = new Date(f.postTime);
                        var day_end = new Date();
                        var total_days = (day_end.valueOf() - day_start.valueOf()) / (1000 * 60 * 60 * 24);
                        var finalDys = Math.round(total_days);
                        if(finalDys == 0) {
                            var minutes = (day_end.valueOf() - day_start.valueOf());
                            var finalMins = Math.round(((minutes % 86400000) % 3600000) / 60000);
                        }
                        finData.push({
                            searchType:1,
                            postId:f.postId,
                            isDevelopmentPost:f.isDevelopmentPost,
                            text:f.text,
                            postDays:finalDys == 0?finalMins+ ' minutes ago':finalDys+' day(s) ago',
                            postTime:f.postTime,
                            postTypeId:f.postTypeId,
                            postCategoryId:f.postCategoryId,
                            userId:f.userId,
                            userName:f.userName,
                            profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
                            viewCount:f.viewCount
                        }) 
                    })
                } 
                const data1 = await this.profileService.getSearchUser(gSearchDto.searchTerm);
                if(data1) {
                    const promises = data1.map(async (u) => {
                        return {
                            postId:0,
                            isDevelopmentPost:false,
                            text:'',
                            postTime:'',
                            postTypeId:0,
                            postCategoryId:0,
                            userId:u.userId,
                            userName: u.firstName != null ? u.firstName :'',
                            profilePic:u.profilePic,
                            viewCount:''
                        }   
                    });   
                    const da = await Promise.all(promises);
                    da.map((f) => {  
                        finData.push({
                            searchType:2,
                            postId:f.postId,
                            isDevelopmentPost:f.isDevelopmentPost,
                            text:f.text,
                            postDays:'',
                            postTime:f.postTime,
                            postTypeId:f.postTypeId,
                            postCategoryId:f.postCategoryId,
                            userId:f.userId,
                            userName:f.userName,
                            profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
                            viewCount:f.viewCount
                        }) 
                    })
                }
                if(finData.length > 0) {
                    response.status = true;
                    response.data = finData;
                    response.statusCode = 50000;
                    response.internalMessage = 'data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                } 
            } else {
                const data = await this.postRepository.find({               
                    where: {text: Like(`%${gSearchDto.searchTerm}%`),status: true},
                    order: { createdAt: 'DESC' }
                });
                if(data) {
                    const promises = data.map(async (post) => {
                    const user = await this.profileService.getUserByUId(post.userId);
                    return {
                        postId:post.Id,
                        isDevelopmentPost:post.isDevelopmentPost == 1?true:false,
                        text:post.text,
                        postTime:post.createdAt,
                        postTypeId:post.postTypeId,
                        postCategoryId:post.postCategoryId,
                        userId:post.userId,
                        userName: user.firstName != null ? user.firstName :'',
                        profilePic:user.profilePic,
                        viewCount:post.viewCount
                    }   
                    });   
                    const da = await Promise.all(promises);
                    da.map((f) => {  
                        var day_start = new Date(f.postTime);
                        var day_end = new Date();
                        var total_days = (day_end.valueOf() - day_start.valueOf()) / (1000 * 60 * 60 * 24);
                        var finalDys = Math.round(total_days);
                        if(finalDys == 0) {
                            var minutes = (day_end.valueOf() - day_start.valueOf());
                            var finalMins = Math.round(((minutes % 86400000) % 3600000) / 60000);
                        }
                        finData.push({
                            searchType:1,
                            postId:f.postId,
                            isDevelopmentPost:f.isDevelopmentPost,
                            text:f.text,
                            postDays:finalDys == 0?finalMins+ ' minutes ago':finalDys+' day(s) ago',
                            postTime:f.postTime,
                            postTypeId:f.postTypeId,
                            postCategoryId:f.postCategoryId,
                            userId:f.userId,
                            userName:f.userName,
                            profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
                            viewCount:f.viewCount
                        }) 
                    })
                } 
                const data1 = await this.profileService.getSearchUser(gSearchDto.searchTerm);
                if(data1) {
                    const promises = data1.map(async (u) => {
                        return {
                            postId:0,
                            isDevelopmentPost:false,
                            text:'',
                            postTime:'',
                            postTypeId:0,
                            postCategoryId:0,
                            userId:u.userId,
                            userName: u.firstName != null ? u.firstName :'',
                            profilePic:u.profilePic,
                            viewCount:''
                        }   
                    });   
                    const da = await Promise.all(promises);
                    da.map((f) => {  
                        finData.push({
                            searchType:2,
                            postId:f.postId,
                            isDevelopmentPost:f.isDevelopmentPost,
                            text:f.text,
                            postDays:'',
                            postTime:f.postTime,
                            postTypeId:f.postTypeId,
                            postCategoryId:f.postCategoryId,
                            userId:f.userId,
                            userName:f.userName,
                            profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
                            viewCount:f.viewCount
                        }) 
                    })
                }
                if(finData.length > 0) {
                    response.status = true;
                    response.data = finData;
                    response.statusCode = 50000;
                    response.internalMessage = 'data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                } 
            }
            return response;
        } catch(error) {
            throw error;
        }
    }

    async updatePostStatus(queryParams, PostDeleteDto:PostDeleteDto, request:Request):Promise<SingleResponseModel> {
        const response = new SingleResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const editPost = await this.postRepository.update({Id:PostDeleteDto.postId},{status:PostDeleteDto.status,updatedUser:PostDeleteDto.updatedUser});
                if(editPost) {
                    response.status = true;
                    response.statusCode = 50000;
                    response.internalMessage = 'Post Deleted Successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Post Not Deleted')
                }
            } else {
                const editPost = await this.postRepository.update({Id:PostDeleteDto.postId},{status:PostDeleteDto.status,updatedUser:PostDeleteDto.updatedUser});
                if(editPost) {
                    response.status = true;
                    response.statusCode = 50000;
                    response.internalMessage = 'Post Deleted Successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Post Not Deleted')
                }
            }
            return response;
        } catch(error) {
            throw error;
        }
    }

    async getPostCategory(queryParams): Promise<AllPCategoryResponseModel> {
        const response = new AllPCategoryResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const activePostCast = await this.postCategoryRepo.find({
                    where: {status: true},
                    order:{Id:'ASC'}
                });
                if(activePostCast) {
                    response.status = true;
                    response.data = activePostCast;
                    response.statusCode = 50000;
                    response.internalMessage = 'data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            } else {
                const activePostCast = await this.postCategoryRepo.find({
                    where: {status: true},
                    order:{Id:'ASC'}
                });
                if(activePostCast) {
                    response.status = true;
                    response.data = activePostCast;
                    response.statusCode = 50000;
                    response.internalMessage = 'data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async applyJob(queryParams, resfile, jobDto:JobDto, request:Request): Promise<SingleResponseModel> { 
        const response = new SingleResponseModel();  
        try {
            if(resfile) {
                jobDto.resume = resfile[0];
            } else {
                jobDto.resume = null;
            }
            jobDto.delFlag = 0;
            const oldData = await this.postRepository.findOne({
                where:{Id:jobDto.postId}
            })
            if(oldData.jobTechCategory) {
                jobDto.techCategory = oldData.jobTechCategory
            } else {
                jobDto.techCategory = jobDto.techCategory
            }

            if(oldData.jobExpDate) {
                jobDto.expDate = oldData.jobExpDate
            } else {
                jobDto.expDate = jobDto.expDate
            }

            if(queryParams.apiVersion == 1) {  
                const saved = await this.pjobsRepo.save({
                    postId: jobDto.postId,
                    userId:jobDto.userId,
                    name: jobDto.name,
                    mobile:jobDto.mobile,
                    email:jobDto.email,
                    techCategory: jobDto.techCategory,
                    expDate: jobDto.expDate,
                    resume:jobDto.resume
                }); 
                
                if(saved) {
                    const postuser = await this.postRepository.findOne({
                        relations:['user'],
                        where:{Id:jobDto.postId}
                    });
                    if(postuser) {
                        const email = postuser.jobEmail;
                        var anothermsg = `<!DOCTYPE HTML><html> <head><meta http-equiv="Content-Type" content="text/html; charset=utf-8">
                        <title>Job Application</title></head>
                        <body style="margin:0; padding:0; font-family:calibri, Arial, Helvetica, sans-serif;">
                        <table width="640" border="0" align="center" cellpadding="0" cellspacing="0">
                        <tr>
                        <td style="background:#ea3e25; text-align:center;">Siasat</td>
                        </tr>
                        <tr>
                        <td style="border:1px solid #ccc; border-top:none;">
                        <table width="100%" border="0" cellspacing="0" cellpadding="0">
                        <tr>
                        <td valign="top" style="padding:20px 10px 20px 20px; font-family:calibri, Arial, Helvetica, sans-serif; font-size:16px; color:#666;">
                        <p style="font-family:calibri, Arial, Helvetica, sans-serif; font-size:20px; color:#333; margin:0 0 10px;">Name: ${jobDto.name},</p>
                        <p style="font-family:calibri, Arial, Helvetica, sans-serif; font-size:16px; color:#666; margin:0 0 20px;">Mobile: ${jobDto.mobile} ,</p>
                        <p style="font-family:calibri, Arial, Helvetica, sans-serif; font-size:16px; color:#666; margin:0 0 20px;">Email: ${jobDto.email} ,</p>
                        <table border="0" cellspacing="0" cellpadding="0">
                        <tr>            
                        </tr>
                        </table>
                        <p style="font-family:calibri, Arial, Helvetica, sans-serif; font-size:16px; color:#666; margin:20px 0;">Applied for the job: ${postuser.text}</p>
                        <p style="font-family:calibri, Arial, Helvetica, sans-serif; font-size:16px; color:#666; margin:0;">Thanks,<br>
                        <strong style="font-family:calibri, Arial, Helvetica, sans-serif; font-size:16px; color:#333;">Team Siasat</strong><br>
                        </p>
                        </td>              
                        </tr>
                        <tr>
                        <td colspan="2" valign="top" style="padding:5px 20px; border-top:1px solid #eee;">
                        <p style=" font-family:calibri, Arial, Helvetica, sans-serif; font-size:12px; color:#999;"></p>
                        </td>
                        </tr>
                        <tr>
                        <td colspan="2" valign="top" style="background:#ccc; padding:5px 0;  font-family:calibri, Arial, Helvetica, sans-serif; font-size:13px; color:#666;text-align:center;">© 2022, All Rights Reserved</td>
                        </tr>
                        </table></td>
                        </tr>
                        </table>
                        </body>
                        </html>`;
                        if(email.length > 0) {                           
                            const resname = saved.resume != null ? `${process.env.WORKINGURL}/${saved.resume}` : '';
                            const emsuc = await this.sendMail(email,anothermsg,resname);
                        }

                        if(jobDto.email.length > 0) {
                            const resname = saved.resume != null ? `${process.env.WORKINGURL}/${saved.resume}` : '';
                            const emsuc = await this.sendMail(jobDto.email,anothermsg,resname);
                        }
                    }
                    response.status = true;
                    response.data   = saved;
                    response.statusCode = 50000;
                    response.internalMessage = 'Job applied successfully';
                    response.intlCode = 11100;
                } else {
                    throw new ErrorResponse(11106, 'Failed to apply job')
                }  
            } else {
                const saved = await this.pjobsRepo.save({
                    postId: jobDto.postId,
                    userId:jobDto.userId,
                    name: jobDto.name,
                    mobile:jobDto.mobile,
                    email:jobDto.email,
                    techCategory: jobDto.techCategory,
                    expDate: jobDto.expDate,
                    resume:jobDto.resume
                }); 
                
                if(saved) {
                    const postuser = await this.postRepository.findOne({
                        relations:['user'],
                        where:{Id:jobDto.postId}
                    });
                    if(postuser) {
                        const email = postuser.jobEmail;
                        var anothermsg = `<!DOCTYPE HTML><html> <head><meta http-equiv="Content-Type" content="text/html; charset=utf-8">
                        <title>Job Application</title></head>
                        <body style="margin:0; padding:0; font-family:calibri, Arial, Helvetica, sans-serif;">
                        <table width="640" border="0" align="center" cellpadding="0" cellspacing="0">
                        <tr>
                        <td style="background:#ea3e25; text-align:center;">Siasat</td>
                        </tr>
                        <tr>
                        <td style="border:1px solid #ccc; border-top:none;">
                        <table width="100%" border="0" cellspacing="0" cellpadding="0">
                        <tr>
                        <td valign="top" style="padding:20px 10px 20px 20px; font-family:calibri, Arial, Helvetica, sans-serif; font-size:16px; color:#666;">
                        <p style="font-family:calibri, Arial, Helvetica, sans-serif; font-size:20px; color:#333; margin:0 0 10px;">Name: ${jobDto.name},</p>
                        <p style="font-family:calibri, Arial, Helvetica, sans-serif; font-size:16px; color:#666; margin:0 0 20px;">Mobile: ${jobDto.mobile} ,</p>
                        <p style="font-family:calibri, Arial, Helvetica, sans-serif; font-size:16px; color:#666; margin:0 0 20px;">Email: ${jobDto.email} ,</p>
                        <table border="0" cellspacing="0" cellpadding="0">
                        <tr>            
                        </tr>
                        </table>
                        <p style="font-family:calibri, Arial, Helvetica, sans-serif; font-size:16px; color:#666; margin:20px 0;">Applied for the job: ${postuser.text}</p>
                        <p style="font-family:calibri, Arial, Helvetica, sans-serif; font-size:16px; color:#666; margin:0;">Thanks,<br>
                        <strong style="font-family:calibri, Arial, Helvetica, sans-serif; font-size:16px; color:#333;">Team Siasat</strong><br>
                        </p>
                        </td>              
                        </tr>
                        <tr>
                        <td colspan="2" valign="top" style="padding:5px 20px; border-top:1px solid #eee;">
                        <p style=" font-family:calibri, Arial, Helvetica, sans-serif; font-size:12px; color:#999;"></p>
                        </td>
                        </tr>
                        <tr>
                        <td colspan="2" valign="top" style="background:#ccc; padding:5px 0;  font-family:calibri, Arial, Helvetica, sans-serif; font-size:13px; color:#666;text-align:center;">© 2022, All Rights Reserved</td>
                        </tr>
                        </table></td>
                        </tr>
                        </table>
                        </body>
                        </html>`;
                        if(email.length > 0) {                           
                            const resname = saved.resume != null ? `${process.env.WORKINGURL}/${saved.resume}` : '';
                            const emsuc = await this.sendMail(email,anothermsg,resname);
                        }

                        if(jobDto.email.length > 0) {
                            const resname = saved.resume != null ? `${process.env.WORKINGURL}/${saved.resume}` : '';
                            const emsuc = await this.sendMail(jobDto.email,anothermsg,resname);
                        }
                    }
                    response.status = true;
                    response.data   = saved;
                    response.statusCode = 50000;
                    response.internalMessage = 'Job applied successfully';
                    response.intlCode = 11100;
                } else {
                    throw new ErrorResponse(11106, 'Failed to apply job')
                }                
            }
            return response;
        } catch(error) {
            throw error;
        }        
    }
    
    async getBreakingPosts(pageDto:Pagination3Dto, userId,request:Request):Promise<AllPostsResponseModel> {
        const response = new AllPostsResponseModel();
        try {
            const finData: any[] = [];
            let finPollData: any[] = []; 
            let images: any[] = [];
            let videos: any[] = [];            
            if(pageDto.apiVersion == 1) {
                if(!pageDto.skip || pageDto.skip == null) {
                    pageDto.skip = 0;
                } 
                var posts = await this.postRepository.find({
                            where:{status:1,postTypeId:5},
                            order: {createdAt: "DESC"},
                            skip:pageDto.skip,
                            take: 10
                }); 
                
                if(!posts) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const promises = posts.map(async (post) => {
                    const user = await this.profileService.getUserByUId(post.userId);
                    const ldfCount = await this.postActService.getPostLikDisLikFavCount(post.Id);
                    const cmtCount =  await this.cmntService.getPostCmtsCount(post.Id);
                    const ldfStatus = await this.postActService.getPostLikDisLikFavStatus(post.Id,userId);
                    const postImages = await this.postFilesService.getPostFiles(post.Id, 'image');
                    const postVideos = await this.postFilesService.getPostFiles(post.Id,'video');
                    const postPoll  = await this.pollService.getPostPoll(post.Id);
                    const postCategory = await this.postCategoryRepo.findOne({where:{Id:post.postCategoryId}});
                    if(postPoll.length > 0) {
                        const pollTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: post.Id })
                        .orderBy('status','ASC')
                        .getRawOne();
                        const tlCount = pollTotal.cnt;
                        const promises = postPoll.map(async (v) => {
                            const optionTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.Id })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .orderBy('status','ASC')
                            .getRawOne();
                            const statusTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.Id })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .andWhere('user_id=:ui',{ui:userId})
                            .orderBy('status','ASC')
                            .getRawOne();                        
                            return  {
                                pollId:v.Id,
                                pollValue:v.pollValue,
                                pollType:v.pollType,
                                polCnt: optionTotal.cnt,
                                usta: statusTotal.cnt > 0 ? true : false
                            }
                        })
                        const pda = await Promise.all(promises);
                        finPollData =[];
                        pda.map((f) => { 
                            finPollData.push({
                                pollId: f.pollId,
                                pollType:f.pollType,
                                pollValue:f.pollValue,
                                totalCount:tlCount,
                                pollCount:f.polCnt,
                                percentage: tlCount == 0 ? 0 : Math.round(f.polCnt / (tlCount / 100)),
                                userStatus: f.usta
                            })
                        });
                    } else {
                        finPollData =[];
                    }
                    //const loguser = await this.profileService.getUserByUId(userId);
                    return {
                        postId:post.Id,
                        isDevelopmentPost:post.isDevelopmentPost == 1? true:false,
                        text:post.text,
                        postTime:post.createdAt,
                        postTypeId:post.postTypeId,
                        postCategoryId:post.postCategoryId,
                        postCategoryName:postCategory != undefined? postCategory.postcategory : '',
                        villageId:post.villageId,
                        villageName:post.village != null? post.village.villageName:'',
                        userId:post.userId,
                        userName: user.firstName != null ? user.firstName :'',
                        profilePic:user.profilePic,
                        likesCount:ldfCount.likeCount,
                        likeStatus:ldfStatus != null ? ldfStatus.like : false,
                        disLikesCount:ldfCount.dislikeCount,
                        disLikeStatus:ldfStatus != null ? ldfStatus.dislike : false,
                        favCount:ldfCount.fevCount,
                        favStatus:ldfStatus != null ? ldfStatus.fev : false,
                        commentCount:cmtCount.cnt,
                        postImages:postImages,
                        postVideos:postVideos,
                        poll:finPollData,
                        pollExpire:post.pollExpire,
                        viewCount:post.viewCount,
                       // timeOffSet:loguser != null?loguser.user.timeZoneOffset:'00:00'
                    }   
                });   
                const da = await Promise.all(promises);
                da.map((f) => {  
                    if(f.postImages) {
                        f.postImages.map((i) => {
                            images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                        })
                    } 
                    if(f.postVideos) { 
                        f.postVideos.map((v) => {
                            videos.push(`${process.env.WORKINGURL}/${v.fileUrl}`)
                        })
                    }                    
                    var day_start = new Date(f.postTime);
                    var day_end = new Date();
                   // console.log(day_start,day_end)
                    var finalDys = this.timeDiffCalc(day_end,day_start)
                    if(f.pollExpire != null){
                        var day_start1 = new Date();
                        var day_end1 = new Date(f.pollExpire);
                        var finalDys1 = this.timeDiffCalc(day_end1,day_start1)
                    } else {
                        var finalDys1 = '';
                    }
                    
                    finData.push({
                        postId:f.postId,
                        isDevelopmentPost:f.isDevelopmentPost,
                        text:f.text,
                        postDays:finalDys,
                        postTime:f.postTime,
                        postTypeId:f.postTypeId,
                        postCategoryId:f.postCategoryId,
                        postCategoryName:f.postCategoryName,
                        villageId:f.villageId,
                        villageName:f.villageName,
                        userId:f.userId,
                        userName:f.userName,
                        profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
                        likesCount:f.likesCount != null ? `${f.likesCount}` : 0,
                        likeStatus:f.likeStatus,
                        disLikesCount:f.disLikesCount !=null ? `${f.disLikesCount}` : 0,
                        disLikeStatus:f.disLikeStatus,
                        favCount:f.favCount !=null ? `${f.favCount}` : 0,
                        favStatus:f.favStatus,
                        commentCount:f.commentCount !=null ? `${f.commentCount}` : 0,
                        postImages:images,
                        postVideos:videos,
                        poll:f.poll,
                        pollExpire:finalDys1,
                        viewCount:f.viewCount
                    }) 
                    images=[];
                    videos=[];
                }) 
                    if(finData.length > 0) { 
                        response.status = true;
                        response.data = finData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Data retrieved successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Data not found');
                    }
            } else {
                if(!pageDto.skip || pageDto.skip == null) {
                    pageDto.skip = 0;
                } 
                var posts = await this.postRepository.find({
                            where:{status:1,postTypeId:5},
                            order: {createdAt: "DESC"},
                            skip:pageDto.skip,
                            take: 10
                }); 
                
                if(!posts) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const promises = posts.map(async (post) => {
                    const user = await this.profileService.getUserByUId(post.userId);
                    const ldfCount = await this.postActService.getPostLikDisLikFavCount(post.Id);
                    const cmtCount =  await this.cmntService.getPostCmtsCount(post.Id);
                    const ldfStatus = await this.postActService.getPostLikDisLikFavStatus(post.Id,userId);
                    const postImages = await this.postFilesService.getPostFiles(post.Id, 'image');
                    const postVideos = await this.postFilesService.getPostFiles(post.Id,'video');
                    const postPoll  = await this.pollService.getPostPoll(post.Id);
                    const postCategory = await this.postCategoryRepo.findOne({where:{Id:post.postCategoryId}});
                    if(postPoll.length > 0) {
                        const pollTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: post.Id })
                        .orderBy('status','ASC')
                        .getRawOne();
                        const tlCount = pollTotal.cnt;
                        const promises = postPoll.map(async (v) => {
                            const optionTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.Id })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .orderBy('status','ASC')
                            .getRawOne();
                            const statusTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.Id })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .andWhere('user_id=:ui',{ui:userId})
                            .orderBy('status','ASC')
                            .getRawOne();                        
                            return  {
                                pollId:v.Id,
                                pollValue:v.pollValue,
                                pollType:v.pollType,
                                polCnt: optionTotal.cnt,
                                usta: statusTotal.cnt > 0 ? true : false
                            }
                        })
                        const pda = await Promise.all(promises);
                        finPollData =[];
                        pda.map((f) => { 
                            finPollData.push({
                                pollId: f.pollId,
                                pollType:f.pollType,
                                pollValue:f.pollValue,
                                totalCount:tlCount,
                                pollCount:f.polCnt,
                                percentage: tlCount == 0 ? 0 : Math.round(f.polCnt / (tlCount / 100)),
                                userStatus: f.usta
                            })
                        });
                    } else {
                        finPollData =[];
                    }
                    //const loguser = await this.profileService.getUserByUId(userId);
                    return {
                        postId:post.Id,
                        isDevelopmentPost:post.isDevelopmentPost == 1? true:false,
                        text:post.text,
                        postTime:post.createdAt,
                        postTypeId:post.postTypeId,
                        postCategoryId:post.postCategoryId,
                        postCategoryName:postCategory != undefined? postCategory.postcategory : '',
                        villageId:post.villageId,
                        villageName:post.village != null? post.village.villageName:'',
                        userId:post.userId,
                        userName: user.firstName != null ? user.firstName :'',
                        profilePic:user.profilePic,
                        likesCount:ldfCount.likeCount,
                        likeStatus:ldfStatus != null ? ldfStatus.like : false,
                        disLikesCount:ldfCount.dislikeCount,
                        disLikeStatus:ldfStatus != null ? ldfStatus.dislike : false,
                        favCount:ldfCount.fevCount,
                        favStatus:ldfStatus != null ? ldfStatus.fev : false,
                        commentCount:cmtCount.cnt,
                        postImages:postImages,
                        postVideos:postVideos,
                        poll:finPollData,
                        pollExpire:post.pollExpire,
                        viewCount:post.viewCount,
                       // timeOffSet:loguser != null?loguser.user.timeZoneOffset:'00:00'
                    }   
                });   
                const da = await Promise.all(promises);
                da.map((f) => {  
                    if(f.postImages) {
                        f.postImages.map((i) => {
                            images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                        })
                    } 
                    if(f.postVideos) { 
                        f.postVideos.map((v) => {
                            videos.push(`${process.env.WORKINGURL}/${v.fileUrl}`)
                        })
                    }                    
                    var day_start = new Date(f.postTime);
                    var day_end = new Date();
                   // console.log(day_start,day_end)
                    var finalDys = this.timeDiffCalc(day_end,day_start)
                    if(f.pollExpire != null){
                        var day_start1 = new Date();
                        var day_end1 = new Date(f.pollExpire);
                        var finalDys1 = this.timeDiffCalc(day_end1,day_start1)
                    } else {
                        var finalDys1 = '';
                    }
                    
                    finData.push({
                        postId:f.postId,
                        isDevelopmentPost:f.isDevelopmentPost,
                        text:f.text,
                        postDays:finalDys,
                        postTime:f.postTime,
                        postTypeId:f.postTypeId,
                        postCategoryId:f.postCategoryId,
                        postCategoryName:f.postCategoryName,
                        villageId:f.villageId,
                        villageName:f.villageName,
                        userId:f.userId,
                        userName:f.userName,
                        profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
                        likesCount:f.likesCount != null ? `${f.likesCount}` : 0,
                        likeStatus:f.likeStatus,
                        disLikesCount:f.disLikesCount !=null ? `${f.disLikesCount}` : 0,
                        disLikeStatus:f.disLikeStatus,
                        favCount:f.favCount !=null ? `${f.favCount}` : 0,
                        favStatus:f.favStatus,
                        commentCount:f.commentCount !=null ? `${f.commentCount}` : 0,
                        postImages:images,
                        postVideos:videos,
                        poll:f.poll,
                        pollExpire:finalDys1,
                        viewCount:f.viewCount
                    }) 
                    images=[];
                    videos=[];
                }) 
                    if(finData.length > 0) { 
                        response.status = true;
                        response.data = finData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Data retrieved successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Data not found');
                    }
            }
            return response;
        } catch(error) {
           throw error;//new ErrorResponse(99998, error);
        }
    }

    async getUnsignedHomePosts(pageDto:PaginationDto, request:Request):Promise<AllPostsResponseModel> {
        const response = new AllPostsResponseModel();
        try {
            const finData: any[] = [];
            let finPollData: any[] = []; 
            let images: any[] = [];
            let videos: any[] = [];            
            if(pageDto.apiVersion == 1) {
                if(!pageDto.skip || pageDto.skip == null) {
                    pageDto.skip = 0;
                } 
                var posts = await this.postRepository.find({
                            where:{status:1},
                            order: {createdAt: "DESC"},
                            skip:pageDto.skip,
                            take: 10
                }); 
                
                if(!posts) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const promises = posts.map(async (post) => {
                    const user = await this.profileService.getUserByUId(post.userId);
                    const ldfCount = await this.postActService.getPostLikDisLikFavCount(post.Id);
                    const cmtCount =  await this.cmntService.getPostCmtsCount(post.Id);
                   // const ldfStatus = await this.postActService.getPostLikDisLikFavStatus(post.Id,userId);
                    const postImages = await this.postFilesService.getPostFiles(post.Id, 'image');
                    const postVideos = await this.postFilesService.getPostFiles(post.Id,'video');
                    const postPoll  = await this.pollService.getPostPoll(post.Id);
                    const postCategory = await this.postCategoryRepo.findOne({where:{Id:post.postCategoryId}});
                    if(postPoll.length > 0) {
                        const pollTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: post.Id })
                        .orderBy('status','ASC')
                        .getRawOne();
                        const tlCount = pollTotal.cnt;
                        const promises = postPoll.map(async (v) => {
                            const optionTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.Id })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .orderBy('status','ASC')
                            .getRawOne();
                            const statusTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.Id })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                           // .andWhere('user_id=:ui',{ui:userId})
                            .orderBy('status','ASC')
                            .getRawOne();                        
                            return  {
                                pollId:v.Id,
                                pollValue:v.pollValue,
                                pollType:v.pollType,
                                polCnt: optionTotal.cnt,
                                usta: statusTotal.cnt > 0 ? true : false
                            }
                        })
                        const pda = await Promise.all(promises);
                        finPollData =[];
                        pda.map((f) => { 
                            finPollData.push({
                                pollId: f.pollId,
                                pollType:f.pollType,
                                pollValue:f.pollValue,
                                totalCount:tlCount,
                                pollCount:f.polCnt,
                                percentage: tlCount == 0 ? 0 : Math.round(f.polCnt / (tlCount / 100)),
                                userStatus: f.usta
                            })
                        });
                    } else {
                        finPollData =[];
                    }
                    //const loguser = await this.profileService.getUserByUId(userId);
                    return {
                        postId:post.Id,
                        isDevelopmentPost:post.isDevelopmentPost == 1? true:false,
                        text:post.text,
                        postTime:post.createdAt,
                        postTypeId:post.postTypeId,
                        postCategoryId:post.postCategoryId,
                        postCategoryName:postCategory != undefined? postCategory.postcategory : '',
                        villageId:post.villageId,
                        villageName:post.village != null? post.village.villageName:'',
                        userId:post.userId,
                        userName: user.firstName != null ? user.firstName :'',
                        profilePic:user.profilePic,
                        likesCount:ldfCount.likeCount,
                        likeStatus: false,
                        disLikesCount:ldfCount.dislikeCount,
                        disLikeStatus: false,
                        favCount:ldfCount.fevCount,
                        favStatus: false,
                        commentCount:cmtCount.cnt,
                        postImages:postImages,
                        postVideos:postVideos,
                        poll:finPollData,
                        pollExpire:post.pollExpire,
                        viewCount:post.viewCount,
                       // timeOffSet:loguser != null?loguser.user.timeZoneOffset:'00:00'
                    }   
                });   
                const da = await Promise.all(promises);
                da.map((f) => {  
                    if(f.postImages) {
                        f.postImages.map((i) => {
                            images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                        })
                    } 
                    if(f.postVideos) { 
                        f.postVideos.map((v) => {
                            videos.push(`${process.env.WORKINGURL}/${v.fileUrl}`)
                        })
                    }                    
                    var day_start = new Date(f.postTime);
                    var day_end = new Date();
                   // console.log(day_start,day_end)
                    var finalDys = this.timeDiffCalc(day_end,day_start)
                    if(f.pollExpire != null){
                        var day_start1 = new Date();
                        var day_end1 = new Date(f.pollExpire);
                        var finalDys1 = this.timeDiffCalc(day_end1,day_start1)
                    } else {
                        var finalDys1 = '';
                    }
                    
                    finData.push({
                        postId:f.postId,
                        isDevelopmentPost:f.isDevelopmentPost,
                        text:f.text,
                        postDays:finalDys,
                        postTime:f.postTime,
                        postTypeId:f.postTypeId,
                        postCategoryId:f.postCategoryId,
                        postCategoryName:f.postCategoryName,
                        villageId:f.villageId,
                        villageName:f.villageName,
                        userId:f.userId,
                        userName:f.userName,
                        profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
                        likesCount:f.likesCount != null ? `${f.likesCount}` : 0,
                        likeStatus:f.likeStatus,
                        disLikesCount:f.disLikesCount !=null ? `${f.disLikesCount}` : 0,
                        disLikeStatus:f.disLikeStatus,
                        favCount:f.favCount !=null ? `${f.favCount}` : 0,
                        favStatus:f.favStatus,
                        commentCount:f.commentCount !=null ? `${f.commentCount}` : 0,
                        postImages:images,
                        postVideos:videos,
                        poll:f.poll,
                        pollExpire:finalDys1,
                        viewCount:f.viewCount
                    }) 
                    images=[];
                    videos=[];
                }) 
                    if(finData.length > 0) { 
                        response.status = true;
                        response.data = finData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Data retrieved successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Data not found');
                    }
            } else {
                if(!pageDto.skip || pageDto.skip == null) {
                    pageDto.skip = 0;
                } 
                var posts = await this.postRepository.find({
                            where:{status:1},
                            order: {createdAt: "DESC"},
                            skip:pageDto.skip,
                            take: 10
                }); 
                
                if(!posts) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const promises = posts.map(async (post) => {
                    const user = await this.profileService.getUserByUId(post.userId);
                    const ldfCount = await this.postActService.getPostLikDisLikFavCount(post.Id);
                    const cmtCount =  await this.cmntService.getPostCmtsCount(post.Id);
                   // const ldfStatus = await this.postActService.getPostLikDisLikFavStatus(post.Id,userId);
                    const postImages = await this.postFilesService.getPostFiles(post.Id, 'image');
                    const postVideos = await this.postFilesService.getPostFiles(post.Id,'video');
                    const postPoll  = await this.pollService.getPostPoll(post.Id);
                    const postCategory = await this.postCategoryRepo.findOne({where:{Id:post.postCategoryId}});
                    if(postPoll.length > 0) {
                        const pollTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: post.Id })
                        .orderBy('status','ASC')
                        .getRawOne();
                        const tlCount = pollTotal.cnt;
                        const promises = postPoll.map(async (v) => {
                            const optionTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.Id })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .orderBy('status','ASC')
                            .getRawOne();
                            const statusTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.Id })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                           // .andWhere('user_id=:ui',{ui:userId})
                            .orderBy('status','ASC')
                            .getRawOne();                        
                            return  {
                                pollId:v.Id,
                                pollValue:v.pollValue,
                                pollType:v.pollType,
                                polCnt: optionTotal.cnt,
                                usta: statusTotal.cnt > 0 ? true : false
                            }
                        })
                        const pda = await Promise.all(promises);
                        finPollData =[];
                        pda.map((f) => { 
                            finPollData.push({
                                pollId: f.pollId,
                                pollType:f.pollType,
                                pollValue:f.pollValue,
                                totalCount:tlCount,
                                pollCount:f.polCnt,
                                percentage: tlCount == 0 ? 0 : Math.round(f.polCnt / (tlCount / 100)),
                                userStatus: f.usta
                            })
                        });
                    } else {
                        finPollData =[];
                    }
                    //const loguser = await this.profileService.getUserByUId(userId);
                    return {
                        postId:post.Id,
                        isDevelopmentPost:post.isDevelopmentPost == 1? true:false,
                        text:post.text,
                        postTime:post.createdAt,
                        postTypeId:post.postTypeId,
                        postCategoryId:post.postCategoryId,
                        postCategoryName:postCategory != undefined? postCategory.postcategory : '',
                        villageId:post.villageId,
                        villageName:post.village != null? post.village.villageName:'',
                        userId:post.userId,
                        userName: user.firstName != null ? user.firstName :'',
                        profilePic:user.profilePic,
                        likesCount:ldfCount.likeCount,
                        likeStatus: false,
                        disLikesCount:ldfCount.dislikeCount,
                        disLikeStatus: false,
                        favCount:ldfCount.fevCount,
                        favStatus: false,
                        commentCount:cmtCount.cnt,
                        postImages:postImages,
                        postVideos:postVideos,
                        poll:finPollData,
                        pollExpire:post.pollExpire,
                        viewCount:post.viewCount,
                       // timeOffSet:loguser != null?loguser.user.timeZoneOffset:'00:00'
                    }   
                });   
                const da = await Promise.all(promises);
                da.map((f) => {  
                    if(f.postImages) {
                        f.postImages.map((i) => {
                            images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                        })
                    } 
                    if(f.postVideos) { 
                        f.postVideos.map((v) => {
                            videos.push(`${process.env.WORKINGURL}/${v.fileUrl}`)
                        })
                    }                    
                    var day_start = new Date(f.postTime);
                    var day_end = new Date();
                   // console.log(day_start,day_end)
                    var finalDys = this.timeDiffCalc(day_end,day_start)
                    if(f.pollExpire != null){
                        var day_start1 = new Date();
                        var day_end1 = new Date(f.pollExpire);
                        var finalDys1 = this.timeDiffCalc(day_end1,day_start1)
                    } else {
                        var finalDys1 = '';
                    }
                    
                    finData.push({
                        postId:f.postId,
                        isDevelopmentPost:f.isDevelopmentPost,
                        text:f.text,
                        postDays:finalDys,
                        postTime:f.postTime,
                        postTypeId:f.postTypeId,
                        postCategoryId:f.postCategoryId,
                        postCategoryName:f.postCategoryName,
                        villageId:f.villageId,
                        villageName:f.villageName,
                        userId:f.userId,
                        userName:f.userName,
                        profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
                        likesCount:f.likesCount != null ? `${f.likesCount}` : 0,
                        likeStatus:f.likeStatus,
                        disLikesCount:f.disLikesCount !=null ? `${f.disLikesCount}` : 0,
                        disLikeStatus:f.disLikeStatus,
                        favCount:f.favCount !=null ? `${f.favCount}` : 0,
                        favStatus:f.favStatus,
                        commentCount:f.commentCount !=null ? `${f.commentCount}` : 0,
                        postImages:images,
                        postVideos:videos,
                        poll:f.poll,
                        pollExpire:finalDys1,
                        viewCount:f.viewCount
                    }) 
                    images=[];
                    videos=[];
                }) 
                    if(finData.length > 0) { 
                        response.status = true;
                        response.data = finData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Data retrieved successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Data not found');
                    }
            }
            return response;
        } catch(error) {
           throw error;//new ErrorResponse(99998, error);
        }
    }

    async getJobs(pageDto:Pagination3Dto, userId,request:Request):Promise<AllPostsResponseModel> {
        const response = new AllPostsResponseModel();
        try {
            const finData: any[] = [];
            let finPollData: any[] = []; 
            let images: any[] = [];
            let videos: any[] = [];            
            if(pageDto.apiVersion == 1) {
                if(!pageDto.skip || pageDto.skip == null) {
                    pageDto.skip = 0;
                } 
                var posts = await this.pjobsRepo.find({
                    relations: ['post','user'],
                    where:{delFlag:0},
                    order: {createdAt: "DESC"},
                    skip:pageDto.skip,
                    take: 10
                }); 
                
                if(!posts) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const promises = posts.map(async (post) => {                    
                    const user = await this.profileService.getUserByUId(post.userId);
                    const ldfCount = await this.postActService.getPostLikDisLikFavCount(post.postId);
                    const cmtCount =  await this.cmntService.getPostCmtsCount(post.postId);
                    const ldfStatus = await this.postActService.getPostLikDisLikFavStatus(post.postId,userId);
                    const postImages = await this.postFilesService.getPostFiles(post.postId, 'image');
                    const postVideos = await this.postFilesService.getPostFiles(post.postId,'video');
                    const postPoll  = await this.pollService.getPostPoll(post.postId);
                    const postCategory = await this.postCategoryRepo.findOne({where:{Id:post.post.postCategoryId}});
                    if(postPoll.length > 0) {
                        const pollTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: post.postId })
                        .orderBy('status','ASC')
                        .getRawOne();
                        const tlCount = pollTotal.cnt;
                        const promises = postPoll.map(async (v) => {
                            const optionTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.postId })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .orderBy('status','ASC')
                            .getRawOne();
                            const statusTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.postId })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .andWhere('user_id=:ui',{ui:userId})
                            .orderBy('status','ASC')
                            .getRawOne();                        
                            return  {
                                pollId:v.Id,
                                pollValue:v.pollValue,
                                pollType:v.pollType,
                                polCnt: optionTotal.cnt,
                                usta: statusTotal.cnt > 0 ? true : false
                            }
                        })
                        const pda = await Promise.all(promises);
                        finPollData =[];
                        pda.map((f) => { 
                            finPollData.push({
                                pollId: f.pollId,
                                pollType:f.pollType,
                                pollValue:f.pollValue,
                                totalCount:tlCount,
                                pollCount:f.polCnt,
                                percentage: tlCount == 0 ? 0 : Math.round(f.polCnt / (tlCount / 100)),
                                userStatus: f.usta
                            })
                        });
                    } else {
                        finPollData =[];
                    }
                    
                    return {
                        postId:post.postId,
                        isDevelopmentPost:post.post.isDevelopmentPost == 1? true:false,
                        text:post.post.text,
                        postTime:post.createdAt,
                        postTypeId:post.post.postTypeId,
                        postCategoryId:post.post.postCategoryId,
                        postCategoryName:postCategory != undefined? postCategory.postcategory : '',
                        villageId:post.post.villageId,
                        villageName:post.post.village != null? post.post.village.villageName:'',
                        userId:post.userId,
                        userName: user != null ? user.firstName :'',
                        profilePic:user != null ? user.profilePic : '',
                        likesCount:ldfCount.likeCount,
                        likeStatus:ldfStatus != null ? ldfStatus.like : false,
                        disLikesCount:ldfCount.dislikeCount,
                        disLikeStatus:ldfStatus != null ? ldfStatus.dislike : false,
                        favCount:ldfCount.fevCount,
                        favStatus:ldfStatus != null ? ldfStatus.fev : false,
                        commentCount:cmtCount.cnt,
                        postImages:postImages,
                        postVideos:postVideos,
                        poll:finPollData,
                        pollExpire:post.post.pollExpire,
                        viewCount:post.post.viewCount,
                        jobemail: post.email,
                        jobmobile: post.mobile,
                        postjobemail: post.post.jobEmail,
                        postjobmobile: post.post.jobMobile,
                        postjobtech: post.post.jobTechCategory,
                        postexpdate: post.post.jobExpDate,
                        resume: post.resume
                    }   
                });   
                const da = await Promise.all(promises);
                da.map((f) => {  
                    if(f.postImages) {
                        f.postImages.map((i) => {
                            images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                        })
                    } 
                    if(f.postVideos) { 
                        f.postVideos.map((v) => {
                            videos.push(`${process.env.WORKINGURL}/${v.fileUrl}`)
                        })
                    }                    
                    var day_start = new Date(f.postTime);
                    var day_end = new Date();
                   // console.log(day_start,day_end)
                    var finalDys = this.timeDiffCalc(day_end,day_start)
                    if(f.pollExpire != null){
                        var day_start1 = new Date();
                        var day_end1 = new Date(f.pollExpire);
                        var finalDys1 = this.timeDiffCalc(day_end1,day_start1)
                    } else {
                        var finalDys1 = '';
                    }
                    
                    finData.push({
                        postId:f.postId,
                        isDevelopmentPost:f.isDevelopmentPost,
                        text:f.text,
                        postDays:finalDys,
                        postTime:f.postTime,
                        postTypeId:f.postTypeId,
                        postCategoryId:f.postCategoryId,
                        postCategoryName:f.postCategoryName,
                        villageId:f.villageId,
                        villageName:f.villageName,
                        userId:f.userId,
                        userName:f.userName,
                        profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
                        likesCount:f.likesCount != null ? `${f.likesCount}` : 0,
                        likeStatus:f.likeStatus,
                        disLikesCount:f.disLikesCount !=null ? `${f.disLikesCount}` : 0,
                        disLikeStatus:f.disLikeStatus,
                        favCount:f.favCount !=null ? `${f.favCount}` : 0,
                        favStatus:f.favStatus,
                        commentCount:f.commentCount !=null ? `${f.commentCount}` : 0,
                        postImages:images,
                        postVideos:videos,
                        poll:f.poll,
                        pollExpire:finalDys1,
                        viewCount:f.viewCount,
                        jobemail: f.jobemail,
                        jobmobile: f.jobmobile,
                        postjobemail: f.postjobemail,
                        postjobmobile: f.postjobmobile,
                        postjobtech: f.postjobtech,
                        postexpdate: f.postexpdate,
                        resume: f.resume != null ? `${process.env.WORKINGURL}/${f.resume}` : '',

                    }) 
                    images=[];
                    videos=[];
                }) 
                if(finData.length > 0) { 
                    response.status = true;
                    response.data = finData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            } else {
                if(!pageDto.skip || pageDto.skip == null) {
                    pageDto.skip = 0;
                } 
                var posts = await this.pjobsRepo.find({
                    relations: ['post','user'],
                    where:{delFlag:0},
                    order: {createdAt: "DESC"},
                    skip:pageDto.skip,
                    take: 10
                }); 
                
                if(!posts) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const promises = posts.map(async (post) => {                    
                    const user = await this.profileService.getUserByUId(post.userId);
                    const ldfCount = await this.postActService.getPostLikDisLikFavCount(post.postId);
                    const cmtCount =  await this.cmntService.getPostCmtsCount(post.postId);
                    const ldfStatus = await this.postActService.getPostLikDisLikFavStatus(post.postId,userId);
                    const postImages = await this.postFilesService.getPostFiles(post.postId, 'image');
                    const postVideos = await this.postFilesService.getPostFiles(post.postId,'video');
                    const postPoll  = await this.pollService.getPostPoll(post.postId);
                    const postCategory = await this.postCategoryRepo.findOne({where:{Id:post.post.postCategoryId}});
                    if(postPoll.length > 0) {
                        const pollTotal = await getConnection()
                        .createQueryBuilder()
                        .select("count(*) as cnt")
                        .from(PollVotingEntity, "PollVoting")
                        .where('post_id=:da', { da: post.postId })
                        .orderBy('status','ASC')
                        .getRawOne();
                        const tlCount = pollTotal.cnt;
                        const promises = postPoll.map(async (v) => {
                            const optionTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.postId })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .orderBy('status','ASC')
                            .getRawOne();
                            const statusTotal = await getConnection()
                            .createQueryBuilder()
                            .select("count(*) as cnt")
                            .from(PollVotingEntity, "PollVoting")
                            .where('post_id=:da', { da: post.postId })
                            .andWhere('poll_id=:pi',{pi:v.Id})
                            .andWhere('user_id=:ui',{ui:userId})
                            .orderBy('status','ASC')
                            .getRawOne();                        
                            return  {
                                pollId:v.Id,
                                pollValue:v.pollValue,
                                pollType:v.pollType,
                                polCnt: optionTotal.cnt,
                                usta: statusTotal.cnt > 0 ? true : false
                            }
                        })
                        const pda = await Promise.all(promises);
                        finPollData =[];
                        pda.map((f) => { 
                            finPollData.push({
                                pollId: f.pollId,
                                pollType:f.pollType,
                                pollValue:f.pollValue,
                                totalCount:tlCount,
                                pollCount:f.polCnt,
                                percentage: tlCount == 0 ? 0 : Math.round(f.polCnt / (tlCount / 100)),
                                userStatus: f.usta
                            })
                        });
                    } else {
                        finPollData =[];
                    }
                    
                    return {
                        postId:post.postId,
                        isDevelopmentPost:post.post.isDevelopmentPost == 1? true:false,
                        text:post.post.text,
                        postTime:post.createdAt,
                        postTypeId:post.post.postTypeId,
                        postCategoryId:post.post.postCategoryId,
                        postCategoryName:postCategory != undefined? postCategory.postcategory : '',
                        villageId:post.post.villageId,
                        villageName:post.post.village != null? post.post.village.villageName:'',
                        userId:post.userId,
                        userName: user != null ? user.firstName :'',
                        profilePic:user != null ? user.profilePic : '',
                        likesCount:ldfCount.likeCount,
                        likeStatus:ldfStatus != null ? ldfStatus.like : false,
                        disLikesCount:ldfCount.dislikeCount,
                        disLikeStatus:ldfStatus != null ? ldfStatus.dislike : false,
                        favCount:ldfCount.fevCount,
                        favStatus:ldfStatus != null ? ldfStatus.fev : false,
                        commentCount:cmtCount.cnt,
                        postImages:postImages,
                        postVideos:postVideos,
                        poll:finPollData,
                        pollExpire:post.post.pollExpire,
                        viewCount:post.post.viewCount,
                        jobemail: post.email,
                        jobmobile: post.mobile,
                        postjobemail: post.post.jobEmail,
                        postjobmobile: post.post.jobMobile,
                        postjobtech: post.post.jobTechCategory,
                        postexpdate: post.post.jobExpDate,
                        resume: post.resume
                    }   
                });   
                const da = await Promise.all(promises);
                da.map((f) => {  
                    if(f.postImages) {
                        f.postImages.map((i) => {
                            images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                        })
                    } 
                    if(f.postVideos) { 
                        f.postVideos.map((v) => {
                            videos.push(`${process.env.WORKINGURL}/${v.fileUrl}`)
                        })
                    }                    
                    var day_start = new Date(f.postTime);
                    var day_end = new Date();
                   // console.log(day_start,day_end)
                    var finalDys = this.timeDiffCalc(day_end,day_start)
                    if(f.pollExpire != null){
                        var day_start1 = new Date();
                        var day_end1 = new Date(f.pollExpire);
                        var finalDys1 = this.timeDiffCalc(day_end1,day_start1)
                    } else {
                        var finalDys1 = '';
                    }
                    
                    finData.push({
                        postId:f.postId,
                        isDevelopmentPost:f.isDevelopmentPost,
                        text:f.text,
                        postDays:finalDys,
                        postTime:f.postTime,
                        postTypeId:f.postTypeId,
                        postCategoryId:f.postCategoryId,
                        postCategoryName:f.postCategoryName,
                        villageId:f.villageId,
                        villageName:f.villageName,
                        userId:f.userId,
                        userName:f.userName,
                        profilePic: f.profilePic != null ? `${process.env.WORKINGURL}/${f.profilePic}` : '',
                        likesCount:f.likesCount != null ? `${f.likesCount}` : 0,
                        likeStatus:f.likeStatus,
                        disLikesCount:f.disLikesCount !=null ? `${f.disLikesCount}` : 0,
                        disLikeStatus:f.disLikeStatus,
                        favCount:f.favCount !=null ? `${f.favCount}` : 0,
                        favStatus:f.favStatus,
                        commentCount:f.commentCount !=null ? `${f.commentCount}` : 0,
                        postImages:images,
                        postVideos:videos,
                        poll:f.poll,
                        pollExpire:finalDys1,
                        viewCount:f.viewCount,
                        jobemail: f.jobemail,
                        jobmobile: f.jobmobile,
                        postjobemail: f.postjobemail,
                        postjobmobile: f.postjobmobile,
                        postjobtech: f.postjobtech,
                        postexpdate: f.postexpdate,
                        resume: f.resume != null ? `${process.env.WORKINGURL}/${f.resume}` : '',

                    }) 
                    images=[];
                    videos=[];
                }) 
                if(finData.length > 0) { 
                    response.status = true;
                    response.data = finData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            }
            return response;
        } catch(error) {
           throw error;//new ErrorResponse(99998, error);
        }
    }


    async changeWhatsAppStatus(queryParams, PostMSGDto:PostMSGDto, request:Request): Promise<SingleResponseModel> { 
        const response = new SingleResponseModel();  
        try {
            var getdt = await this.apsetRepo.findOne({
                where:{type:PostMSGDto.type}
            });
            var final = {
                status : PostMSGDto.status
            }

            if(queryParams.apiVersion == 1) {  
                
                if(getdt) {
                    const saved =  await this.apsetRepo.update(getdt.Id,{status:PostMSGDto.status}); 
                    if(saved) {
                        response.status = true;
                        response.data   = saved;
                        response.statusCode = 50000;
                        response.internalMessage = 'Service status changed successfully';
                        response.intlCode = 11100;
                    } else {
                        throw new ErrorResponse(11106, 'Failed to change status')
                    }
                } else {
                    throw new ErrorResponse(11106, 'Failed to change status')
                }                 
            } else 
            return response;
        } catch(error) {
            throw error;
        }        
    }
    
}
